import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  CardActionArea,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  DialogTitle,
  DialogActions,
  Collapse,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Avatar from 'antd/es/avatar/avatar';
import {
  buyerCounterOffer,
  confirmBuyerOffer,
  forwardBuyeractiontoVendor,
  forwardOfferToBuyer,
  forwardOfferToVendor,
  getApiCall,
  Moxoseparationinlisting,
  offerWithdrawVendor,
  formatBasedOnUserType,
  formatDateTime,
} from 'api/apiService';
import Arrow1 from 'assets/images/Arrow1.png';
import Loading from 'assets/images/loading.png';
import { highManageStarStyle } from 'component/BuyerRegistration/BuyerRegistration.style';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import Offeractivity from 'component/Offeractivity/Offeractivity';
import {
  GET_AGENT_MANAGEOFFER,
  GET_BINDERID,
  GET_BUYER_MANAGEOFFER,
  GET_VENDOR_MANAGEOFFER,
  OFFER_ACTIVITY,
  OFFER_ACTIVITY_VENDOR,
} from 'constant/app.config';
import {
  DownArrowRed,
  Uparrow,
} from 'component/BuyersMarketplace/Marketplaceicons';
import dayjs from 'dayjs';
import { isArray } from 'lodash';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { HighStar } from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails';
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2';
import { poppins400, poppins500 } from 'theme/common.style';
import { Contact } from './BuyerRegistration.util';
import BadgeButton from './components/BadgeButton';
import Moxochat from 'component/Moxochat/Moxochat';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { AiInfoIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CounterOfferTable from './CounterOfferTable';
import PrivateOfferDetails from './PrivateOfferDetails';
import { WarningIconYELLOW } from './PrivateOfferDetails';
import CampaignRestrictedPopup from 'component/BuyersMarketplace/CampaignRestrictedPopup';
import CounterOfferalreadyexists from './components/CounterOfferalreadyexists';
import ShareOfferWithMarketPlace from './ShareOfferWithMarketPlace';
import MeterChartOffer from './MeterChartOffer';
import AdditionalConditionTooltip from 'component/Common/AdditionalConditionTooltip';
import NameTooltip from 'component/Common/NameTooltip';
const isNotEmptyArray = (arr) =>
  Array.isArray(arr) &&
  arr.length > 0 &&
  !arr.every((item) => Array.isArray(item) && item.length === 0);

const Offer = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#F93939"
        fill-opacity="0.1"
      />
      <path
        d="M22.5945 14.426C22.5945 14.8593 22.4861 15.2667 22.2695 15.648C22.0615 16.0293 21.7495 16.35 21.3335 16.61C20.9261 16.87 20.4408 17.026 19.8775 17.078V18.131H19.0325V17.078C18.2178 17 17.5591 16.7443 17.0565 16.311C16.5538 15.8777 16.3025 15.3057 16.3025 14.595H17.8885C17.9145 14.933 18.0228 15.2147 18.2135 15.44C18.4041 15.6567 18.6771 15.7953 19.0325 15.856V12.996C18.4518 12.8487 17.9795 12.7013 17.6155 12.554C17.2515 12.398 16.9395 12.1553 16.6795 11.826C16.4281 11.4967 16.3025 11.046 16.3025 10.474C16.3025 9.75467 16.5538 9.161 17.0565 8.693C17.5591 8.21633 18.2178 7.939 19.0325 7.861V6.808H19.8775V7.861C20.6401 7.93033 21.2511 8.173 21.7105 8.589C22.1785 8.99633 22.4428 9.55967 22.5035 10.279H20.9175C20.8915 10.0103 20.7875 9.772 20.6055 9.564C20.4235 9.34733 20.1808 9.2 19.8775 9.122V11.93C20.4581 12.0687 20.9305 12.216 21.2945 12.372C21.6585 12.5193 21.9661 12.7577 22.2175 13.087C22.4688 13.4077 22.5945 13.854 22.5945 14.426ZM17.8105 10.396C17.8105 10.7513 17.9145 11.0287 18.1225 11.228C18.3391 11.4273 18.6425 11.5877 19.0325 11.709V9.083C18.6598 9.12633 18.3608 9.26067 18.1355 9.486C17.9188 9.71133 17.8105 10.0147 17.8105 10.396ZM19.8775 15.856C20.2588 15.7953 20.5578 15.6437 20.7745 15.401C20.9911 15.1497 21.0995 14.8507 21.0995 14.504C21.0995 14.1573 20.9911 13.8887 20.7745 13.698C20.5665 13.4987 20.2675 13.3383 19.8775 13.217V15.856Z"
        fill="#F93939"
      />
      <path
        d="M32.9396 21.6849C32.3232 20.6363 30.9564 20.237 29.8348 20.7777L26.1887 22.4292C25.6853 21.5318 24.7196 20.9605 23.6569 20.9318L20.291 20.8429C19.7581 20.8283 19.2351 20.6987 18.7613 20.4642L18.4188 20.2941C16.6651 19.4178 14.5749 19.42 12.8231 20.2997L12.8445 19.5559C12.8515 19.3095 12.649 19.1043 12.392 19.0976L8.70108 19.0002C8.44404 18.9934 8.23018 19.1875 8.22313 19.4339L8.00018 27.1985C7.99313 27.4449 8.19563 27.6501 8.45268 27.6569L12.1436 27.7542H12.1565C12.4086 27.754 12.6147 27.5617 12.6217 27.3203L12.6322 26.9488L13.5911 26.4566C13.9674 26.2625 14.4076 26.2163 14.8188 26.3279L20.5444 27.8684C20.5544 27.8712 20.5644 27.8734 20.5747 27.8756C20.9885 27.9586 21.4103 28.0002 21.8333 28C22.7287 28.0004 23.6137 27.8155 24.4276 27.4573C24.4476 27.4486 24.4669 27.4386 24.4853 27.4272L32.7871 22.2793C32.9941 22.1512 33.0609 21.8904 32.9396 21.6849ZM8.94358 26.7769L9.14085 19.9048L11.9013 19.9775L11.7038 26.8499L8.94358 26.7769ZM24.008 26.6599C22.9969 27.0974 21.8676 27.2181 20.7808 27.005L15.0704 25.4688C14.4279 25.2945 13.7397 25.3669 13.1517 25.6699L12.6617 25.9213L12.7931 21.352C14.3456 20.3621 16.3369 20.2603 17.9906 21.0862L18.3331 21.2564C18.9317 21.5527 19.5922 21.7163 20.2656 21.7348L23.6315 21.8237C24.5769 21.8496 25.3799 22.495 25.5717 23.383L20.5581 23.2507C20.301 23.244 20.0872 23.4381 20.0801 23.6845C20.0731 23.9309 20.2756 24.1361 20.5326 24.1429L26.0655 24.2889H26.0787C26.3305 24.2887 26.5367 24.0963 26.5437 23.8549C26.5494 23.661 26.5342 23.4669 26.4987 23.276L30.2378 21.5821L30.2487 21.5771C30.7791 21.3196 31.4207 21.4056 31.8569 21.7928L24.008 26.6599Z"
        fill="#F93939"
      />
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      width="30"
      height="27"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="1"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M17.8291 7.19042L23.3192 7.19042L23.3192 12.6949"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23 7.5L17.75 12.75"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14.1748 21.8106L8.68467 21.8106L8.68467 16.3061"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 16.2559L9 21.5059"
        stroke="#606060"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

const NeedHelp = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25220_146967)">
        <path
          d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 17.7085V17.7189"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25220_146967">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Hotspot = ({ color = '#666666' }) => {
  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const iconSize = matches500
    ? { width: 16, height: 12 }
    : { width: 22, height: 17 };

  return (
    <svg
      width={iconSize.width}
      height={iconSize.height}
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7779 0.189784C18.6476 0.0767684 18.4752 0.0152416 18.2971 0.0181661C18.119 0.0210906 17.9491 0.0882381 17.8231 0.205462C17.6971 0.322686 17.625 0.480834 17.6218 0.646588C17.6187 0.812342 17.6848 0.97276 17.8062 1.09405C18.7014 1.92489 19.4113 2.91222 19.895 3.99925C20.3788 5.08628 20.6268 6.25158 20.625 7.42815C20.625 9.90207 19.5488 12.1397 17.8062 13.7614C17.6809 13.882 17.6116 14.0436 17.6131 14.2114C17.6145 14.3791 17.6868 14.5396 17.8142 14.6583C17.9416 14.777 18.114 14.8443 18.2942 14.8459C18.4745 14.8474 18.6482 14.783 18.7779 14.6665C19.8008 13.717 20.612 12.5887 21.1649 11.3465C21.7179 10.1043 22.0017 8.7727 22 7.42815C22 4.60105 20.768 2.04096 18.7779 0.189784ZM4.19375 1.09405C4.31519 0.97276 4.38131 0.812342 4.37816 0.646588C4.37502 0.480834 4.30287 0.322686 4.17691 0.205462C4.05095 0.0882381 3.88101 0.0210906 3.7029 0.0181661C3.52479 0.0152416 3.35242 0.0767684 3.22209 0.189784C2.19921 1.13934 1.388 2.26762 0.83505 3.5098C0.282105 4.75199 -0.00167578 6.0836 7.44418e-06 7.42815C7.44418e-06 10.2544 1.23201 12.8145 3.22209 14.6665C3.35242 14.7795 3.52479 14.8411 3.7029 14.8381C3.88101 14.8352 4.05095 14.7681 4.17691 14.6508C4.30287 14.5336 4.37502 14.3755 4.37816 14.2097C4.38131 14.044 4.31519 13.8835 4.19375 13.7623C3.29859 12.9314 2.58873 11.9441 2.10499 10.857C1.62124 9.77001 1.37316 8.60471 1.37501 7.42815C1.37501 4.95422 2.45117 2.71575 4.19375 1.09405ZM7.43417 4.10968C7.55561 3.98839 7.62172 3.82797 7.61858 3.66222C7.61544 3.49646 7.54328 3.33832 7.41732 3.22109C7.29136 3.10387 7.12142 3.03672 6.94332 3.0338C6.76521 3.03087 6.59283 3.0924 6.4625 3.20541C5.86586 3.75941 5.39271 4.41764 5.07023 5.14231C4.74774 5.86697 4.58228 6.6438 4.58334 7.42815C4.58228 8.2125 4.74774 8.98932 5.07023 9.71399C5.39271 10.4387 5.86586 11.0969 6.4625 11.6509C6.59223 11.7674 6.76592 11.8318 6.94618 11.8303C7.12644 11.8287 7.29884 11.7614 7.42625 11.6427C7.55366 11.524 7.62588 11.3635 7.62736 11.1957C7.62884 11.028 7.55946 10.8664 7.43417 10.7458C6.96525 10.3105 6.59344 9.79321 6.34016 9.22369C6.08688 8.65417 5.95712 8.04366 5.95834 7.4273C5.95736 6.81122 6.08724 6.20103 6.34051 5.63182C6.59379 5.06261 6.96546 4.54476 7.43417 4.10968ZM15.5375 3.20541C15.4746 3.14255 15.3987 3.09213 15.3143 3.05717C15.23 3.0222 15.139 3.00339 15.0466 3.00188C14.9543 3.00036 14.8626 3.01616 14.777 3.04834C14.6914 3.08052 14.6137 3.12842 14.5484 3.18917C14.4831 3.24993 14.4316 3.3223 14.3971 3.40197C14.3625 3.48163 14.3455 3.56697 14.3471 3.65287C14.3488 3.73878 14.369 3.8235 14.4065 3.90198C14.4441 3.98047 14.4983 4.0511 14.5658 4.10968C15.0348 4.54496 15.4066 5.06224 15.6598 5.63176C15.9131 6.20127 16.0429 6.81178 16.0417 7.42815C16.0428 8.04437 15.9129 8.65472 15.6597 9.22408C15.4064 9.79345 15.0346 10.3106 14.5658 10.7458C14.4983 10.8043 14.4441 10.875 14.4065 10.9535C14.369 11.0319 14.3488 11.1167 14.3471 11.2026C14.3455 11.2885 14.3625 11.3738 14.3971 11.4535C14.4316 11.5331 14.4831 11.6055 14.5484 11.6663C14.6137 11.727 14.6914 11.7749 14.777 11.8071C14.8626 11.8393 14.9543 11.8551 15.0466 11.8536C15.139 11.8521 15.23 11.8333 15.3143 11.7983C15.3987 11.7633 15.4746 11.7129 15.5375 11.65C16.134 11.0961 16.6071 10.438 16.9296 9.71353C17.2521 8.98902 17.4176 8.21236 17.4167 7.42815C17.4176 6.64394 17.2521 5.86728 16.9296 5.14277C16.6071 4.41825 16.134 3.7593 15.5375 3.20541ZM12.8333 7.42815C12.8335 7.76815 12.7245 8.10044 12.5204 8.38239C12.3162 8.66435 12.0262 8.88311 11.6875 9.01061V16.1722C11.6875 16.3419 11.6151 16.5046 11.4861 16.6246C11.3572 16.7446 11.1823 16.812 11 16.812C10.8177 16.812 10.6428 16.7446 10.5139 16.6246C10.3849 16.5046 10.3125 16.3419 10.3125 16.1722V9.01061C10.0042 8.89453 9.73557 8.70259 9.53549 8.45533C9.33541 8.20806 9.21137 7.91481 9.17667 7.60696C9.14197 7.29912 9.19791 6.98829 9.3385 6.70777C9.4791 6.42725 9.69904 6.18761 9.97478 6.01452C10.2505 5.84142 10.5717 5.7414 10.9038 5.72516C11.2359 5.70891 11.5666 5.77707 11.8603 5.92231C12.154 6.06756 12.3997 6.28443 12.5711 6.54969C12.7425 6.81496 12.8332 7.11862 12.8333 7.42815Z"
        fill="#666666"
      />
    </svg>
  );
};
const ContractReview = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.1" width="30" height="30" rx="5" fill="#6C2AD2" />
      <path
        d="M16.7046 13.8406C16.5539 13.6899 16.3089 13.6899 16.1582 13.8406L15.2727 14.7261V6.38636C15.2727 6.1731 15.0996 6 14.8864 6C14.6731 6 14.5 6.1731 14.5 6.38636V15.6588C14.5 15.8149 14.5943 15.9563 14.7388 16.0158C14.7867 16.0359 14.8369 16.0451 14.8864 16.0451C14.9868 16.0451 15.0857 16.0057 15.1591 15.9323L16.7046 14.3869C16.8552 14.2363 16.8552 13.9913 16.7046 13.8406Z"
        fill="#6C2AD2"
      />
      <path
        d="M15.1579 15.385L13.6124 13.8396C13.4618 13.6889 13.2168 13.6889 13.0661 13.8396C12.9155 13.9902 12.9155 14.2352 13.0661 14.3859L14.6115 15.9313C14.6873 16.0062 14.7862 16.0441 14.8851 16.0441C14.984 16.0441 15.0829 16.0063 15.1579 15.9313C15.3085 15.7806 15.3085 15.5357 15.1579 15.385Z"
        fill="#6C2AD2"
      />
      <path
        d="M23.3178 14.4732L20.5322 10.2945C20.0292 9.54032 19.1877 9.08984 18.2821 9.08984H16.4315C16.2182 9.08984 16.0451 9.26294 16.0451 9.47621C16.0451 9.68947 16.2182 9.86257 16.4315 9.86257H18.2821C18.9288 9.86257 19.53 10.184 19.8893 10.7226L22.6749 14.9014C22.8874 15.2197 22.9994 15.5906 22.9994 15.9731V21.0667C22.9994 21.7058 22.4794 22.2258 21.8404 22.2258H7.93174C7.29271 22.2258 6.77269 21.7058 6.77269 21.0667V16.0302C6.77269 15.6169 6.90174 15.222 7.15749 14.872L9.65641 11.0795C10.1587 10.3169 11.0032 9.86253 11.915 9.86253H13.3406C13.5539 9.86253 13.727 9.68944 13.727 9.47617C13.727 9.2629 13.5539 9.08984 13.3407 9.08984H11.915C10.7421 9.08984 9.65645 9.67477 9.01122 10.6546L6.52313 14.4315C6.18081 14.899 6 15.4515 6 16.0302V21.0667C6 22.1315 6.86697 22.9985 7.93174 22.9985H21.8404C22.9051 22.9985 23.7721 22.1315 23.7721 21.0667V15.9731C23.7721 15.4376 23.6153 14.9191 23.3178 14.4732Z"
        fill="#6C2AD2"
      />
      <path
        d="M22.9998 15.2734H21.0681C20.0033 15.2734 19.1363 16.1404 19.1363 17.2052C19.1363 17.8442 18.6163 18.3642 17.9773 18.3642H11.7957C11.1566 18.3642 10.6366 17.8442 10.6366 17.2052C10.6366 16.1404 9.76963 15.2734 8.70486 15.2734H6.77308C6.55982 15.2734 6.38672 15.4465 6.38672 15.6598C6.38672 15.8731 6.55982 16.0461 6.77308 16.0461H8.70482C9.34386 16.0461 9.86388 16.5661 9.86388 17.2052C9.86388 18.27 10.7308 19.1369 11.7956 19.1369H17.9772C19.042 19.1369 19.909 18.27 19.909 17.2052C19.909 16.5661 20.429 16.0461 21.0681 16.0461H22.9998C23.2131 16.0461 23.3862 15.873 23.3862 15.6598C23.3862 15.4465 23.2131 15.2734 22.9998 15.2734Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
const SixtysixW = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_106_4)">
        <path
          opacity="0.1"
          d="M25 0H5C2.23858 0 0 2.23858 0 5V25C0 27.7614 2.23858 30 5 30H25C27.7614 30 30 27.7614 30 25V5C30 2.23858 27.7614 0 25 0Z"
          fill="#6C2AD2"
        />
        <g clip-path="url(#clip1_106_4)">
          <path
            d="M20.1571 9.73628C20.1094 9.68948 20.0513 9.65103 19.9859 9.62313C19.9206 9.59524 19.8494 9.57844 19.7764 9.5737C19.7034 9.56896 19.63 9.57637 19.5603 9.5955C19.4907 9.61464 19.4263 9.64512 19.3706 9.68522C19.315 9.72532 19.2693 9.77424 19.2362 9.8292C19.203 9.88416 19.1831 9.94407 19.1774 10.0055C19.1718 10.067 19.1806 10.1287 19.2033 10.1873C19.2261 10.2459 19.2623 10.3002 19.31 10.347L20.1701 11.1916C20.2223 11.2429 20.287 11.284 20.3599 11.3123C20.4327 11.3406 20.5119 11.3554 20.5921 11.3555H20.5937C20.6736 11.3556 20.7526 11.3411 20.8253 11.3131C20.898 11.2851 20.9627 11.2443 21.015 11.1935L23.0612 9.20591C23.1091 9.15934 23.1457 9.10528 23.1688 9.04683C23.1919 8.98837 23.2011 8.92666 23.1958 8.86521C23.1906 8.80376 23.171 8.74379 23.1382 8.68871C23.1054 8.63363 23.0601 8.58452 23.0047 8.54419C22.9494 8.50386 22.8851 8.47309 22.8157 8.45365C22.7462 8.43422 22.6729 8.42648 22.5998 8.43089C22.5268 8.4353 22.4555 8.45177 22.3901 8.47936C22.3246 8.50695 22.2663 8.54512 22.2183 8.59169L20.5957 10.1673L20.1571 9.73628Z"
            fill="#6C2AD2"
          />
          <path
            d="M23.6963 9.92152C23.5486 9.92031 23.4064 9.96809 23.3003 10.0545C23.1943 10.1409 23.1329 10.259 23.1296 10.3832C23.1214 10.7922 22.9697 11.1901 22.6937 11.5268C22.4177 11.8635 22.0296 12.1241 21.5781 12.2758C21.1266 12.4276 20.632 12.4637 20.1562 12.3797C19.6804 12.2956 19.2448 12.0952 18.904 11.8035C18.5631 11.5118 18.3323 11.1418 18.2405 10.7401C18.1487 10.3384 18.2 9.92287 18.3879 9.54561C18.5759 9.16835 18.8921 8.84622 19.2969 8.61969C19.7017 8.39315 20.177 8.2723 20.6631 8.27231C20.811 8.27231 20.9528 8.22287 21.0574 8.13486C21.162 8.04686 21.2208 7.9275 21.2208 7.80305C21.2208 7.67859 21.162 7.55924 21.0574 7.47123C20.9528 7.38323 20.811 7.33379 20.6631 7.33379C19.955 7.33326 19.2629 7.51036 18.675 7.84247C18.5873 7.59938 18.4092 7.38637 18.167 7.23473C17.9248 7.0831 17.6312 7.00082 17.3293 7H9.90874C9.82281 7.00044 9.73819 7.01776 9.66161 7.05057C9.65205 7.05454 9.64313 7.0588 9.63389 7.06326C9.58998 7.08357 9.54953 7.10877 9.51362 7.13818L5.39385 10.6047C5.29441 10.6902 5.23798 10.8047 5.23633 10.9243L5.23047 10.9228V19.3355C5.23087 19.651 5.37999 19.9534 5.6451 20.1765C5.9102 20.3996 6.26965 20.525 6.64456 20.5254H8.61539V21.6999C8.61577 22.0153 8.76487 22.3178 9.02998 22.5409C9.29509 22.764 9.65456 22.8894 10.0295 22.8898H20.7142C21.0892 22.8895 21.4487 22.764 21.7138 22.5409C21.9789 22.3179 22.1281 22.0154 22.1284 21.6999V13.0927C22.7476 12.8576 23.2749 12.4798 23.6495 12.003C24.024 11.5262 24.2305 10.9698 24.2449 10.3984C24.2472 10.274 24.1907 10.1538 24.0879 10.0644C23.985 9.975 23.8442 9.9236 23.6963 9.92152ZM9.35107 8.60199V10.2227C9.35098 10.2875 9.32033 10.3497 9.26584 10.3955C9.21135 10.4414 9.13747 10.4672 9.06041 10.4673H7.13442L9.35107 8.60199ZM8.77878 12.969C8.72619 13.0139 8.685 13.0674 8.6577 13.1261C8.63039 13.1848 8.61754 13.2476 8.61992 13.3106L8.61539 13.3088V19.5869H6.64456C6.56536 19.5867 6.48945 19.5602 6.43345 19.5131C6.37745 19.466 6.34593 19.4021 6.34581 19.3355V11.4057H9.06041C9.43317 11.4053 9.79053 11.2805 10.0541 11.0587C10.3177 10.8369 10.466 10.5362 10.4664 10.2226V7.93852H17.3293C17.4085 7.93862 17.4844 7.96514 17.5404 8.01226C17.5964 8.05939 17.6279 8.12327 17.628 8.18991V8.75422C17.4853 8.9459 17.3688 9.15056 17.2807 9.36428H13.2901L13.291 9.369C13.1446 9.36783 13.0037 9.41558 12.8991 9.50176L8.77878 12.969ZM12.7357 10.9665V12.5872C12.7355 12.6519 12.7049 12.714 12.6505 12.7598C12.5961 12.8056 12.5223 12.8314 12.4453 12.8315H10.5193L12.7357 10.9665ZM21.0131 21.6999C21.013 21.7665 20.9814 21.8304 20.9254 21.8775C20.8694 21.9246 20.7935 21.9511 20.7143 21.9512H10.0295C9.95029 21.9511 9.87437 21.9246 9.81838 21.8775C9.76238 21.8304 9.73086 21.7665 9.73073 21.6999V13.7699H12.4453C12.818 13.7695 13.1753 13.6448 13.4389 13.4231C13.7024 13.2013 13.8506 12.9006 13.851 12.587V10.3028H17.0834C17.0831 10.3181 17.0807 10.3328 17.0807 10.3481C17.0817 11.1473 17.4595 11.9134 18.1311 12.4785C18.8026 13.0436 19.7131 13.3615 20.6629 13.3624C20.781 13.3624 20.8977 13.3571 21.013 13.3475L21.0131 21.6999Z"
            fill="#6C2AD2"
          />
          <path
            d="M18.9321 14.6562H11.6553C11.5074 14.6562 11.3656 14.7057 11.261 14.7937C11.1564 14.8817 11.0977 15.0011 11.0977 15.1255C11.0977 15.25 11.1564 15.3693 11.261 15.4573C11.3656 15.5453 11.5074 15.5948 11.6553 15.5948H18.9321C19.08 15.5948 19.2218 15.5453 19.3264 15.4573C19.431 15.3693 19.4898 15.25 19.4898 15.1255C19.4898 15.0011 19.431 14.8817 19.3264 14.7937C19.2218 14.7057 19.08 14.6562 18.9321 14.6562Z"
            fill="#6C2AD2"
          />
          <path
            d="M16.5636 16.3164H11.6553C11.5074 16.3164 11.3656 16.3658 11.261 16.4538C11.1564 16.5418 11.0977 16.6612 11.0977 16.7857C11.0977 16.9101 11.1564 17.0295 11.261 17.1175C11.3656 17.2055 11.5074 17.2549 11.6553 17.2549H16.5636C16.7115 17.2549 16.8533 17.2055 16.9579 17.1175C17.0625 17.0295 17.1213 16.9101 17.1213 16.7857C17.1213 16.6612 17.0625 16.5418 16.9579 16.4538C16.8533 16.3658 16.7115 16.3164 16.5636 16.3164Z"
            fill="#6C2AD2"
          />
          <path
            d="M16.5692 19.4585H15.315C15.2127 19.4584 15.1145 19.4241 15.0421 19.3632C14.9697 19.3023 14.929 19.2197 14.9288 19.1335V19.0638C14.9288 18.9318 14.8862 18.8023 14.8054 18.6891C14.7246 18.5759 14.6088 18.4833 14.4703 18.4213C14.3318 18.3593 14.1759 18.3301 14.0192 18.3369C13.8625 18.3437 13.711 18.3863 13.5809 18.46L11.6762 19.5384C11.5534 19.6078 11.4685 19.7155 11.4401 19.8376C11.4117 19.9597 11.442 20.0864 11.5246 20.1897C11.6071 20.2929 11.735 20.3644 11.8802 20.3883C12.0253 20.4123 12.1758 20.3867 12.2986 20.3172L13.8569 19.4353C13.9375 19.7096 14.1248 19.9533 14.3891 20.1276C14.6534 20.3019 14.9794 20.3967 15.3152 20.3971H16.5693C16.7172 20.3971 16.8591 20.3476 16.9636 20.2596C17.0682 20.1716 17.127 20.0523 17.127 19.9278C17.127 19.8034 17.0682 19.684 16.9636 19.596C16.8591 19.508 16.7171 19.4585 16.5692 19.4585Z"
            fill="#6C2AD2"
          />
          <path
            d="M18.9381 19.457H18.292C18.1441 19.457 18.0023 19.5065 17.8977 19.5945C17.7931 19.6825 17.7344 19.8018 17.7344 19.9263C17.7344 20.0507 17.7931 20.1701 17.8977 20.2581C18.0023 20.3461 18.1441 20.3955 18.292 20.3955H18.9381C19.086 20.3955 19.2278 20.3461 19.3324 20.2581C19.437 20.1701 19.4958 20.0507 19.4958 19.9263C19.4958 19.8018 19.437 19.6825 19.3324 19.5945C19.2278 19.5065 19.086 19.457 18.9381 19.457Z"
            fill="#6C2AD2"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_106_4">
          <rect width="30" height="30" fill="white" />
        </clipPath>
        <clipPath id="clip1_106_4">
          <rect
            width="20"
            height="16"
            fill="white"
            transform="translate(5 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const Warning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};
const Reject = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.43868 0.477416C0.71993 0.196515 1.10118 0.0387361 1.49868 0.0387361C1.89618 0.0387361 2.27743 0.196515 2.55868 0.477416L12.9987 10.9174L23.4387 0.477416C23.576 0.330042 23.7416 0.211838 23.9256 0.129854C24.1096 0.0478701 24.3082 0.00378701 24.5096 0.000233445C24.711 -0.00332012 24.9111 0.0337287 25.0979 0.109171C25.2847 0.184613 25.4543 0.296902 25.5968 0.439339C25.7392 0.581777 25.8515 0.751444 25.9269 0.938221C26.0024 1.125 26.0394 1.32506 26.0359 1.52646C26.0323 1.72787 25.9882 1.92649 25.9062 2.11049C25.8243 2.29449 25.7061 2.46009 25.5587 2.59742L15.1187 13.0374L25.5587 23.4774C25.7061 23.6147 25.8243 23.7803 25.9062 23.9643C25.9882 24.1483 26.0323 24.347 26.0359 24.5484C26.0394 24.7498 26.0024 24.9498 25.9269 25.1366C25.8515 25.3234 25.7392 25.4931 25.5968 25.6355C25.4543 25.7779 25.2847 25.8902 25.0979 25.9657C24.9111 26.0411 24.711 26.0782 24.5096 26.0746C24.3082 26.071 24.1096 26.027 23.9256 25.945C23.7416 25.863 23.576 25.7448 23.4387 25.5974L12.9987 15.1574L2.55868 25.5974C2.27433 25.8624 1.89824 26.0066 1.50963 25.9998C1.12103 25.9929 0.750262 25.8355 0.475436 25.5607C0.20061 25.2858 0.0431867 24.9151 0.0363302 24.5265C0.0294738 24.1379 0.17372 23.7618 0.43868 23.4774L10.8787 13.0374L0.43868 2.59742C0.157779 2.31617 0 1.93492 0 1.53742C0 1.13991 0.157779 0.758667 0.43868 0.477416Z"
        fill="rgba(249, 57, 57, 1)"
      />
    </svg>
  );
};
const Accept = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11L11 21L31 1"
        stroke="rgba(16, 211, 94, 1)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const CounterOff = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.53125 27.1196C5.23777 30.556 7.98207 33.345 11.361 35.0768C14.74 36.8086 18.5754 37.3918 22.3042 36.741C26.033 36.09 29.4582 34.2392 32.0772 31.4604C34.696 28.6814 36.3702 25.1212 36.8542 21.3022C37.338 17.4832 36.6058 13.607 34.7654 10.2428C32.9248 6.87866 30.0728 4.2039 26.6284 2.61146C23.1838 1.019 19.3284 0.592758 15.6284 1.39538C11.9284 2.19798 8.89601 4.02276 6.38875 6.90624C6.08515 7.22646 4.91809 8.51874 3.94789 10.4687"
        stroke="rgba(255, 0, 255, 1)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.8625 10.6266L2.78194 12.4401L1 2.17969"
        stroke="rgba(255, 0, 255, 1)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const SortUpcoloricon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="rotate(180, 16, 21)">
        <path
          d="M19.002 25.1777L16.8192 27.506V11.6795C16.8192 11.4102 16.7189 11.1519 16.5404 10.9615C16.3618 10.771 16.1197 10.6641 15.8672 10.6641C15.6148 10.6641 15.3726 10.771 15.1941 10.9615C15.0156 11.1519 14.9153 11.4102 14.9153 11.6795V27.506L12.7324 25.1777C12.5529 24.9927 12.3124 24.8904 12.0628 24.8927C11.8132 24.895 11.5745 25.0018 11.398 25.1901C11.2215 25.3783 11.1213 25.633 11.1192 25.8993C11.117 26.1655 11.213 26.422 11.3864 26.6135L15.1942 30.6753C15.3729 30.8653 15.6149 30.9721 15.8673 30.9721C16.1196 30.9721 16.3617 30.8653 16.5404 30.6753L20.3482 26.6135C20.5222 26.4221 20.6187 26.1654 20.6168 25.8988C20.6149 25.6321 20.5148 25.377 20.338 25.1885C20.1612 25 19.9221 24.8931 19.6721 24.8911C19.4221 24.8891 19.1815 24.992 19.002 25.1777Z"
          fill="#0065FC"
        />
        <g transform="scale(-1, 1) translate(-31, 0)">
          <path
            d="M19.6746 14.7262H29.1942C29.4467 14.7262 29.6888 14.6192 29.8673 14.4288C30.0459 14.2383 30.1462 13.9801 30.1462 13.7107C30.1462 13.4414 30.0459 13.1832 29.8673 12.9927C29.6888 12.8023 29.4467 12.6953 29.1942 12.6953H19.6746C19.4221 12.6953 19.18 12.8023 19.0015 12.9927C18.823 13.1832 18.7227 13.4414 18.7227 13.7107C18.7227 13.9801 18.823 14.2383 19.0015 14.4288C19.18 14.6192 19.4221 14.7262 19.6746 14.7262Z"
            fill="#0065FC"
          />
          <path
            d="M29.1942 16.7578H19.6746C19.4221 16.7578 19.18 16.8648 19.0015 17.0552C18.823 17.2457 18.7227 17.5039 18.7227 17.7732C18.7227 18.0426 18.823 18.3008 19.0015 18.4913C19.18 18.6817 19.4221 18.7887 19.6746 18.7887H29.1942C29.4467 18.7887 29.6888 18.6817 29.8673 18.4913C30.0459 18.3008 30.1462 18.0426 30.1462 17.7732C30.1462 17.5039 30.0459 17.2457 29.8673 17.0552C29.6888 16.8648 29.4467 16.7578 29.1942 16.7578Z"
            fill="#0065FC"
          />
          <path
            d="M26.3383 20.8184H19.6746C19.4221 20.8184 19.18 20.9253 19.0015 21.1158C18.823 21.3062 18.7227 21.5645 18.7227 21.8338C18.7227 22.1031 18.823 22.3614 19.0015 22.5518C19.18 22.7422 19.4221 22.8492 19.6746 22.8492H26.3383C26.5908 22.8492 26.8329 22.7422 27.0115 22.5518C27.19 22.3614 27.2903 22.1031 27.2903 21.8338C27.2903 21.5645 27.19 21.3062 27.0115 21.1158C26.8329 20.9253 26.5908 20.8184 26.3383 20.8184Z"
            fill="#0065FC"
          />
        </g>
      </g>
      <rect
        opacity="0.1"
        x="0.704102"
        y="1.13281"
        width="40"
        height="40"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

const Sorticon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.002 25.1777L16.8192 27.506V11.6795C16.8192 11.4102 16.7189 11.1519 16.5404 10.9615C16.3618 10.771 16.1197 10.6641 15.8672 10.6641C15.6148 10.6641 15.3726 10.771 15.1941 10.9615C15.0156 11.1519 14.9153 11.4102 14.9153 11.6795V27.506L12.7324 25.1777C12.5529 24.9927 12.3124 24.8904 12.0628 24.8927C11.8132 24.895 11.5745 25.0018 11.398 25.1901C11.2215 25.3783 11.1213 25.633 11.1192 25.8993C11.117 26.1655 11.213 26.422 11.3864 26.6135L15.1942 30.6753C15.3729 30.8653 15.6149 30.9721 15.8673 30.9721C16.1196 30.9721 16.3617 30.8653 16.5404 30.6753L20.3482 26.6135C20.5222 26.4221 20.6187 26.1654 20.6168 25.8988C20.6149 25.6321 20.5148 25.377 20.338 25.1885C20.1612 25 19.9221 24.8931 19.6721 24.8911C19.4221 24.8891 19.1815 24.992 19.002 25.1777Z"
        fill="#666666"
      />
      <path
        d="M19.6746 14.7262H29.1942C29.4467 14.7262 29.6888 14.6192 29.8673 14.4288C30.0459 14.2383 30.1462 13.9801 30.1462 13.7107C30.1462 13.4414 30.0459 13.1832 29.8673 12.9927C29.6888 12.8023 29.4467 12.6953 29.1942 12.6953H19.6746C19.4221 12.6953 19.18 12.8023 19.0015 12.9927C18.823 13.1832 18.7227 13.4414 18.7227 13.7107C18.7227 13.9801 18.823 14.2383 19.0015 14.4288C19.18 14.6192 19.4221 14.7262 19.6746 14.7262Z"
        fill="#666666"
      />
      <path
        d="M29.1942 16.7578H19.6746C19.4221 16.7578 19.18 16.8648 19.0015 17.0552C18.823 17.2457 18.7227 17.5039 18.7227 17.7732C18.7227 18.0426 18.823 18.3008 19.0015 18.4913C19.18 18.6817 19.4221 18.7887 19.6746 18.7887H29.1942C29.4467 18.7887 29.6888 18.6817 29.8673 18.4913C30.0459 18.3008 30.1462 18.0426 30.1462 17.7732C30.1462 17.5039 30.0459 17.2457 29.8673 17.0552C29.6888 16.8648 29.4467 16.7578 29.1942 16.7578Z"
        fill="#666666"
      />
      <path
        d="M26.3383 20.8184H19.6746C19.4221 20.8184 19.18 20.9253 19.0015 21.1158C18.823 21.3062 18.7227 21.5645 18.7227 21.8338C18.7227 22.1031 18.823 22.3614 19.0015 22.5518C19.18 22.7422 19.4221 22.8492 19.6746 22.8492H26.3383C26.5908 22.8492 26.8329 22.7422 27.0115 22.5518C27.19 22.3614 27.2903 22.1031 27.2903 21.8338C27.2903 21.5645 27.19 21.3062 27.0115 21.1158C26.8329 20.9253 26.5908 20.8184 26.3383 20.8184Z"
        fill="#666666"
      />
      <rect
        opacity="0.1"
        x="0.704102"
        y="1.13281"
        width="40"
        height="40"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

const ForwardOff = ({ isEnabled }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 10.4361H8.65C7.33768 10.4356 6.05019 10.774 4.9267 11.4145C3.80322 12.055 2.88648 12.9734 2.2756 14.0703C2.25843 13.8667 2.24989 13.6626 2.25 13.4583C2.25 9.2854 5.8316 5.90278 10.25 5.90278V2.125L18.25 8.16944L10.25 14.2139V10.4361Z"
        fill={isEnabled ? '#606060' : '#C5C5C5'}
      />
    </svg>
  );
};

export default function ManageOffer(props) {
  const {
    setTabDAta,
    onClose,
    setManageOffer,
    open,
    getListInfo,
    lineChart,
    offerUniqueId,
    address,
    row,
    vendorDatas,
    propertyId,
    buyerId,
    updatefunc,
    offerUniqueIds,
    getBuyerIndividualValue,
    groupCall,
    groupIt,
    propertyDetails,
    tableData,
    vendorStatus,
    moxouserId,
    setOpenhistorydialog,
    Glass,
    agentSubText,
    vendorside,
    offerIsFinal,
    userTypeValue,
    viewBuyerHistory,
    setViewBuyerHistory,
    badgebtnManageOffer,
    isVendorHistoryId,
    autoScrollEnabled,
    setAutoScrollEnabled,
    setIsBuyerDashboardView,
    isBannerView,
    handleMakeOfferClick,
    setVendorGeneratePdf,
    privateOfferDetailsOpen,
    setPrivateOfferDetailsOpen,
    setManageOfferDatas,
    setOpensolicitorpopup,
    setTypeofsolicitorpopup,
  } = props;
  const ishistoryId = row?.buyerOfferDetails?.historyId;
  const vendorHistoryId = row?.buyerOfferDetails?.historyIdVendor;
  const offerHistoryRef = useRef(null);
  const [manualScrollDetected, setManualScrollDetected] = useState(false);
  const [finalOfferUniqueId, setFinalOfferUniqueId] = useState('');
  const [finalBuyerOfferPrice, setFinalBuyerOfferPrice] = useState('');
  const stg2UnconditionalOnly =
    vendorDatas?.PropertyDetails?.stageTwoCondition?.UnconditionalOnly;
  const [pendingOfferType, setPendingOfferType] = useState('');

  const scrollToOfferHistory = () => {
    setTimeout(() => {
      if (offerHistoryRef.current) {
        offerHistoryRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        window.scrollBy(0, 100);
      }
    }, 100);
  };
  const handleUserScroll = () => {
    if (autoScrollEnabled) {
      setAutoScrollEnabled(false);
    }
  };

  useEffect(() => {
    if (viewBuyerHistory || autoScrollEnabled) {
      scrollToOfferHistory();
    }
  }, [viewBuyerHistory, autoScrollEnabled]);

  useEffect(() => {
    const handleScroll = () => {
      if (!manualScrollDetected) {
        setManualScrollDetected(true);
      }
      handleUserScroll();
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [manualScrollDetected]);

  const theme = useTheme();
  const { realTimeLog, setIschatopen } = useContext(datacontext);
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches380 = useMediaQuery(theme.breakpoints.down(380));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches401 = useMediaQuery(theme.breakpoints.down(401));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches650 = useMediaQuery(theme.breakpoints.down(650));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches800 = useMediaQuery(theme.breakpoints.down(800));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [openVendorStatusBox, setOpenVendorStatusBox] = React.useState(false);
  const [forwardVendorLoading, setForwardVendorLoading] = React.useState(false);
  const [
    openforwardbuyeractiontovendorBox,
    setOpenForwardBuyerActionToVendorBox,
  ] = React.useState(false);
  const [buyerToVendorLoading, setBuyerToVendorLoading] = React.useState(false);
  const [openCounterOffer, setOpenCounterOffer] = React.useState(false);
  const [vendorAction, setVendorAction] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [itemObj, setItemObj] = React.useState({});
  const [vendorOffer, setVendorOffer] = React.useState('');

  useEffect(() => {
    if (vendorDatas?.counterSuggestedValue != null) {
      setVendorOffer(String(vendorDatas?.counterSuggestedValue));
    }
  }, [vendorDatas?.counterSuggestedValue]);

  const [errorMessage, setErrorMessage] = React.useState({
    helperText: '',
    error: false,
  });
  const [manageOfferData, setManageOfferData] = useState({});
  const [manageOfferDataClone, setManageOfferDataClone] = useState({});
  const [loader, setLoader] = useState(false);
  const [buyerLoader, setBuyerLoader] = useState(false);
  const [frdOfferToVendorLoading, setFrdOfferToVendorLoading] = useState(false);
  const [openBox, setOpenBox] = useState(false);
  const [openOfferVal, setOpenOfferVal] = useState(false);
  const [buyeracceptcounter, setBuyeracceptcounter] = useState(false);
  const [openOfferValLoader, setOpenOfferValLoader] = useState(false);
  const [shareMarketPlace, setShareMarketPlace] = useState(false);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [openhistory, setOpenHistory] = useState(false);
  const [offerdata, setOfferdata] = useState(null);
  const [tablerow, setTablerow] = useState([]);

  const [sortIcon, setSortIcon] = useState(<Sorticon />);
  const [isSortClicked, setIsSortClicked] = useState(false);

  const [tableOfferData, setTableOfferData] = useState(false);

  let offerValidation = isArray(manageOfferData?.offerHistory)
    ? manageOfferData?.offerHistory[0]?.historyStatus
    : '';

  const vendorOfferField = String(vendorOffer).replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ','
  );
  const handleSortClick = () => {
    setIsSortClicked((prev) => !prev);

    setSortIcon(isSortClicked ? <Sorticon /> : <SortUpcoloricon />);
    setManageOfferData((prev) => ({
      ...prev,
      offerHistory: [...prev.offerHistory].reverse(),
    }));
  };

  const currentAmount = Number(
    manageOfferData?.buyerDetails?.currentOffer?.replace(/[$,]/g, '')
  );

  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));

  useEffect(() => {
    if (buyerLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [buyerLoader]);

  const getdata = () => {
    let url = '';
    if (primaryUserTypeValue == 'Vendor') {
      url = OFFER_ACTIVITY_VENDOR;
    } else {
      url = OFFER_ACTIVITY;
    }
    getApiCall(url + `/${params?.dashboardId}`).then((res) => {
      setOfferdata(res?.data?.offerActivity);
      const wholedata = res?.data?.offerActivity;
      let newArray = wholedata?.slice().reverse();
      let data = [];
      if (newArray?.length > 0) {
        newArray.map((item, index) => {
          let a = parseInt(item.offerPrice.replace(/\$|,/g, ''), 10);
          let b = parseInt(
            newArray[index + 1]?.offerPrice.replace(/\$|,/g, ''),
            10
          );
          let percentage = b
            ? a < b
              ? '-' + ((b - a) * 100) / b
              : ((a - b) * 100) / b
            : 0;
          let formatteddate = dayjs(item?.createdAt)
            .locale('en')
            .format('HH:mm:ss DD-MM-YYYY');
          let innerdata = {
            id: item?.offerLogId,
            Name:
              primaryUserTypeValue == 'Vendor'
                ? item?.buyerName +
                  ' ' +
                  item?.buyerSurName?.charAt(0).toUpperCase()
                : item?.buyerName + ' ' + item?.buyerSurName,
            Offer: item?.offerPrice,
            'Offer Date & Time': formatteddate,
            '% chng': b
              ? percentage < 1 && percentage > 0
                ? Number(percentage).toFixed(4) + '%'
                : Math.round(percentage) + '%'
              : '_',
            'Offer Type':
              item?.isConditional == 1 ? 'Conditional' : 'Unconditional',
            'Vendor Status': item?.vendorStatus
              ? item?.vendorStatus
              : 'No response',
          };
          data.push(innerdata);
        });
        setTablerow(data);
      }
    });
  };

  useEffect(() => {
    if (primaryUserTypeValue !== 'Buyer') {
      getdata();
    }
  }, [openhistory, realTimeLog]);

  const getManageOfferData = () => {
    if (userType == 'Agent') {
      getApiCall(
        GET_AGENT_MANAGEOFFER + `/${buyerId}` + `/${params?.dashboardId}`
      ).then(async (res) => {
        if (res?.status == 200) {
          setManageOfferData(res?.data);
          setManageOfferDataClone(res?.data);
        }
      });
    } else if (userType == 'Vendor') {
      getApiCall(
        GET_VENDOR_MANAGEOFFER + `/${buyerId}` + `/${params?.dashboardId}`
      ).then(async (res) => {
        if (res?.status == 200) {
          setManageOfferData(res?.data);
          setManageOfferDataClone(res?.data);
        }
      });
    } else if (userType == 'Buyer') {
      getApiCall(GET_BUYER_MANAGEOFFER + `/${propertyId}`).then(async (res) => {
        if (res?.status == 200) {
          setManageOfferData(res?.data);
          setManageOfferDataClone(res?.data);
        } else {
          setLoader(false);
        }
      });
    }
  };

  const withdrawLastFun = () => {
    setOpenOfferValLoader(true);
    const input = {
      offerUniqueId: row?.buyerOfferDetails?.offerUniqueId,
      offerStatus: isArray(manageOfferData?.offerHistory)
        ? manageOfferData?.offerHistory[0]?.historyStatus
        : '',
      offerStatusId: isArray(manageOfferData?.offerHistory)
        ? manageOfferData?.offerHistory[0]?.offerStatusId
        : '',
    };
    offerWithdrawVendor(input)
      .then((res) => {
        if (res?.status == 1) {
          getManageOfferData();
          setOpenOfferValLoader(false);
          setOpenOfferVal(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
          getListInfo('apiupdated', params?.dashboardId);
          setOpenOfferValLoader(false);
        } else {
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
          setOpenOfferValLoader(false);
        }
      })
      .catch(() => setOpenOfferValLoader(false));
  };

  const onShowChatt = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };

  const history = useHistory();

  const submitOffer = (amount) => {
    setBuyeracceptcounter(false);
    setBuyerLoader(true);
    var txt = amount;
    var vendorOffer = txt?.match(/\d/g);
    vendorOffer = vendorOffer?.join('');

    const input = {
      offerUniqueId:
        getBuyerIndividualValue?.PropertyDetails?.offerStatus?.offerUniqueId,
      buyerStatus: 'Accepted',
      vendorOfferPrice: vendorOffer,
    };
    confirmBuyerOffer(input)
      .then(async (res) => {
        if (res?.status == '1') {
          getManageOfferData();
          setBuyerLoader(false);
          setBuyeracceptcounter(!buyeracceptcounter);
          if (isNotEmptyArray(res?.dataForBuyerCounterAck))
            Moxoseparationinlisting(
              'dataForBuyerCounterAck',
              res?.dataForBuyerCounterAck
            ); //1
          await Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            html: `<span style="font-family: Poppins; font-size: 16px; color: #666666; font-weight: 400;">
                    You have accepted the vendor’s counter offer of  
                    <span><b style="font-family: Poppins; font-weight: 550; color:#666666">${amount}</b></span>
                 </span>`,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setBuyerLoader(false);
          setBuyeracceptcounter(!buyeracceptcounter);
          await Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
        groupIt();
        groupCall();
      })
      .catch((err) => setBuyerLoader(false));
  };

  const bottomRef = useRef('');

  let scrollDown = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }
  };

  useEffect(() => {
    scrollDown();
  }, [openCounterOffer]);

  useEffect(() => {
    if (!isSortClicked) {
      getManageOfferData();
    }
  }, [updatefunc, realTimeLog, buyerId, open]);

  useEffect(() => {
    if (!open && modalIsOpen) {
      setModalIsOpen(false);
    }
  }, [open]);

  const params = useParams();

  const ClickCounterOff = () => {
    setOpenCounterOffer(true);
  };
  const ClickCounterOffClose = () => {
    return setOpenCounterOffer(false);
  };

  const buyeraction = () => {
    let input = {
      offerUniqueId: row?.buyerOfferDetails?.offerUniqueId,
    };
    setBuyerToVendorLoading(true);
    forwardBuyeractiontoVendor(input)
      .then((res) => {
        if (res?.status == '1') {
          getManageOfferData();
          setOpenForwardBuyerActionToVendorBox(
            !openforwardbuyeractiontovendorBox
          );
          getListInfo();
          setBuyerToVendorLoading(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setBuyerToVendorLoading(false);
          setOpenForwardBuyerActionToVendorBox(
            !openforwardbuyeractiontovendorBox
          );

          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setBuyerToVendorLoading(false));
  };

  function CircularProgressWithProfile(props) {
    let { data } = props;
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={100}
        />
        <CircularProgress
          variant="determinate"
          value={data}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={100}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.profileImage == '' || props.profileImage == null ? (
              <Avatar
                style={{
                  width: '82px',
                  height: '82px',
                  fontFamily: 'poppins',
                  fontSize: '40px',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt={props.name}
                src={props?.profileImage}
                style={{
                  width: '82px',
                  height: '82px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  }

  const dataa = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(dataa);
  const userType = userDetail?.primaryUserType;

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;
    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChatt(resp?.data?.binderId);
      });
    }
  };

  const directcommBinder = (binderId) => {
    onShowChatt(binderId);
  };

  const userID = userDetail?.userId;

  const ownerDetails = vendorDatas?.PropertyDetails?.propertyOwnerDetails;
  const getPrimaryOwner = ownerDetails?.some(
    (val) => val.isPrimary === 1 && val?.user?.userId == userID
  );

  const [lastItem] = manageOfferDataClone?.offerHistory?.slice(0) || [{}];

  const notifyLabels = {
    'Offer Received': 'Notify Vendor',
    'Vendor Notified': 'Notify Vendor',
    'Buyer Notified': 'Notify Buyer',
    Accepted: 'Notify Buyer',
    Rejected: 'Notify Buyer',
    'Counter Offer': 'Notify Buyer',
  };

  const getLabelForNotify = (val) => notifyLabels[val] || 'Notify Buyer';

  const [openDialog, setOpenDialog] = useState(false);
  const [loadingReject, setRejectLoading] = useState(false);
  const [selectedBuyerName, setSelectedBuyerName] = useState('');
  const [selectedBuyerSurName, setSelectedBuyerSurName] = useState('');
  const [currentOfferPrice, setCurrentOfferPrice] = useState('');

  const handleVendorActionClick = (buyerName, buyerSurName, currentOffer) => {
    setSelectedBuyerName(buyerName);
    setSelectedBuyerSurName(buyerSurName);
    setCurrentOfferPrice(currentOffer);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleConfirm = async (buyerName, buyerSurName, currentOffer) => {
    setRejectLoading(true);

    try {
      await updateFunction(buyerName, buyerSurName, currentOffer);
      setOpenDialog(false);
    } catch (error) {
    } finally {
      setRejectLoading(false);
    }
  };

  const updateFunction = (buyerName, buyerSurName, currentOffer) => {
    setLoading(true);
    setLoader(true);

    let input = {
      offerUniqueId: lineChart
        ? offerUniqueId
        : itemObj?.offerUniqueId
        ? itemObj?.offerUniqueId
        : itemObj?.buyerOfferDetails?.offerUniqueId,
      vendorOfferStatus: vendorAction,
      vendorCounterOffer:
        vendorAction === 'Counter Offer' ? vendorOffer.replace(/,/g, '') : 0,
    };
    buyerCounterOffer(input)
      .then((res) => {
        if (vendorAction === 'Counter Offer' && vendorOffer === 0) {
          setErrorMessage({
            ...errorMessage,
            helperText: 'Please fill this field',
            error: true,
          });
          return;
        }
        if (res?.status == '1') {
          if (vendorAction == 'Counter Offer') {
            setOpenCounterOffer(false);
          }
          getManageOfferData();
          setLoading(false);
          setLoader(false);
          setVendorOffer('');
          setVendorAction('');
          let message = '';

          if (vendorAction == 'Counter Offer') {
            message = `<span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                                Your counter Offer of
                               </span>
                               <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                                 $${Number(vendorOffer).toLocaleString('en-US')}
                               </span>
                               <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                                has been lodged. Please complete the pending e-sign request to submit your counter offer to 
                               </span>
                               <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                                ${buyerName} ${buyerSurName
              ?.charAt(0)
              .toUpperCase()}
                               </span>`;
          } else if (vendorAction == 'Accepted') {
            message = `<span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                                You have accepted
                               </span>
                               <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                                ${buyerName} ${buyerSurName
              ?.charAt(0)
              .toUpperCase()}
                               </span>
                               <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                                's offer of
                               </span>
                               <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                                ${currentOffer.toLocaleString()}
                               </span>
                               <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                                . Please complete the pending E-Sign request to have your acceptance submitted to
                               </span>
                               <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                                ${buyerName} ${buyerSurName
              ?.charAt(0)
              .toUpperCase()}
                               </span>`;
          } else if (vendorAction == 'Rejected') {
            message = `<span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                                You have rejected
                               </span>
                               <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                                ${buyerName} ${buyerSurName
              ?.charAt(0)
              .toUpperCase()}
                               </span>
                               <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                                's offer of
                               </span>
                               <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                                ${currentOffer.toLocaleString()}
                               </span>
                              `;
          } else {
            message = res?.message;
          }

          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            html: message,
            showConfirmButton: true,
            showCancelButton: vendorAction.includes('Rejected') ? false : true,
            icon: 'success',
            confirmButtonText: vendorAction.includes('Rejected')
              ? 'Close'
              : 'E-Sign',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              getListInfo('apiupdated', params?.dashboardId).then(() => {
                setTimeout(() => {
                  const updatedBinderId = res?.selectAcceptanceBinderId;
                  setManageOffer(false);
                  if (vendorAction != 'Rejected' && updatedBinderId) {
                  }
                }, 1000);
              });
              if (vendorAction != 'Rejected') {
                setManageOffer(false);
                setVendorGeneratePdf(true);
              }
              if (lineChart) {
                setManageOffer(false);
              } else {
              }
              return;
            } else if (result.isDismissed) {
              getListInfo('apiupdated', params?.dashboardId);
              if (vendorAction != 'Rejected') {
                setManageOffer(false);
              }
              if (lineChart) {
                setManageOffer(false);
              } else {
              }
              return;
            }
          });
        } else {
          setLoading(false);
          setLoader(false);
          setVendorOffer('');
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              if (lineChart) {
                setManageOffer(false);
              } else {
                onClose();
              }
              return;
            } else if (result.isDenied) {
              if (lineChart) {
                setManageOffer(false);
              } else {
                onClose();
              }
              return;
            }
          });
        }
      })
      .catch(() => {
        setLoading(false);
        setLoader(false);
      });
  };

  const dialogConfig = {
    Rejected: {
      title: 'Reject Offer',
      question: 'Would you like to reject',
      confirmText: 'Submit',
      icon: <Pendingwarning matchesmd={matchesmd} />,
    },
    Accepted: {
      title: 'Accept Offer',
      question: 'Would you like to accept the offer of',
      confirmText: 'Submit',
      icon: <Pendingwarning matchesmd={matchesmd} />,
    },
    'Counter Offer': {
      title: 'Submit Counter Offer',
      question: 'Are you sure you would you like to submit a counter offer of',
      confirmText: 'Submit',
      icon: <Pendingwarning matchesmd={matchesmd} />,
    },
  };
  const currentDialog = dialogConfig[vendorAction] || {};

  const [isHovered, setIsHovered] = useState(false);
  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
  };

  const textStyle = {
    visibility: 'hidden',
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'center',
    borderRadius: '6px',
    padding: '5px 10px',
    position: 'absolute',
    zIndex: 1,
    bottom: '125%',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    boxShadow: '8px 8px 8px 8px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
  };

  const textVisibleStyle = {
    ...textStyle,
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 0.3s',
  };

  const [expandedIndex, setExpandedIndex] = useState(null);
  const [isManualInteraction, setIsManualInteraction] = useState(false);

  const contentRef = useRef([]);

  useEffect(() => {
    const scrollToElement = () => {
      if (expandedIndex != null && contentRef.current[expandedIndex]) {
        contentRef.current[expandedIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    };

    scrollToElement();
  }, [expandedIndex]);

  useEffect(() => {
    const scrollToElement = () => {
      if (expandedIndex != null && contentRef.current[expandedIndex]) {
        contentRef.current[expandedIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    };

    if (lineChart && !isManualInteraction) {
      if (offerUniqueId && manageOfferData?.offerHistory?.length > 0) {
        const filteredItems = manageOfferData.offerHistory.filter(
          (item) => item?.offerUniqueId == offerUniqueId
        );

        if (filteredItems.length > 0) {
          const firstIndex = manageOfferData.offerHistory.indexOf(
            filteredItems[0]
          );
          setExpandedIndex(firstIndex);
          setTimeout(scrollToElement, 100);
        }
      }
    } else if (
      badgebtnManageOffer &&
      !isVendorHistoryId &&
      !isManualInteraction
    ) {
      if (ishistoryId && manageOfferData?.offerHistory?.length > 0) {
        const matchedIndex = manageOfferData.offerHistory.findIndex(
          (item) => item?.historyId == ishistoryId
        );
        if (matchedIndex !== -1) {
          setExpandedIndex(matchedIndex);
          setTimeout(scrollToElement, 100);
        }
      }
    } else if (
      badgebtnManageOffer &&
      isVendorHistoryId &&
      !isManualInteraction
    ) {
      if (ishistoryId && manageOfferData?.offerHistory?.length > 0) {
        const matchedIndex = manageOfferData.offerHistory.findIndex(
          (item) => item?.historyId == vendorHistoryId
        );
        if (matchedIndex !== -1) {
          setExpandedIndex(matchedIndex);
          setTimeout(scrollToElement, 100);
        }
      }
    } else if (
      open &&
      expandedIndex != null &&
      contentRef.current[expandedIndex]
    ) {
      contentRef.current[expandedIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }

    return () => {
      if (!open) {
        contentRef.current = [];
      }
    };
  }, [
    lineChart,
    badgebtnManageOffer,
    offerUniqueId,
    manageOfferData,
    ishistoryId,
    open,
    expandedIndex,
    isManualInteraction,
  ]);

  const toggleExpand = (index) => {
    if (userType == 'Agent') {
      getListInfo();
    }
    setIsManualInteraction(true);
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const [offerPopupUniqueId, setOfferPopupUniqueId] = useState('');
  const [offerPopupPrice, setOfferPopupPrice] = useState('');
  const [buyerOfferPrice, setBuyerOfferPrice] = useState('');
  const [vendorStatusHistory, setVendorStatusHistory] = useState('');
  const [showCounterPopup, setShowCounterPopup] = useState(false);
  const [shouldTriggerConfirmAfterPopup, setShouldTriggerConfirmAfterPopup] =
    useState(false);
  const [openFromForwardIconClick, setOpenFromForwardIconClick] =
    useState(false);
  const [sharedToMarket, setSharedToMarket] = useState();

  useEffect(() => {
    if (shouldTriggerConfirmAfterPopup) {
      setShouldTriggerConfirmAfterPopup(false); // reset so it doesn't loop

      // ✅ Re-trigger the same onClick logic without showing popup
      // Put your exact API calling logic here

      let newArr = [];
      let obj = {
        offerUniqueId: lineChart
          ? offerUniqueId
          : offerPopupUniqueId
          ? offerPopupUniqueId
          : offerUniqueIds
          ? row?.offerUniqueId
          : finalOfferUniqueId,
      };
      newArr.push(obj);

      let input = {
        offerUniqueId: newArr,
        offerStatus: vendorStatusHistory
          ? vendorStatusHistory
          : vendorStatus
          ? vendorStatus
          : offerUniqueIds
          ? row?.status
          : row?.buyerOfferDetails?.offerStatus,
        ...(vendorStatusHistory == 'Counter Offer'
          ? { vendorCounterPrice: offerPopupPrice?.replace(/\D/g, '') }
          : lastItem?.historyStatus == 'Counter Offer'
          ? { vendorCounterPrice: lastItem?.offerPrice?.replace(/\D/g, '') }
          : {}),
      };

      setForwardVendorLoading(true);
      forwardOfferToBuyer(input)
        .then((res) => {
          if (res?.status == '1') {
            if (isNotEmptyArray(res?.dataForBuyerAck))
              Moxoseparationinlisting(
                'offerSharingToBuyer',
                res?.dataForBuyerAck
              );
            const successMessage =
              vendorStatusHistory == 'Accepted' ||
              vendorStatusHistory == 'Rejected' ||
              vendorStatus == 'Accepted' ||
              vendorStatus == 'Rejected' ||
              row?.status == 'Accepted' ||
              row?.status == 'Rejected' ||
              row?.buyerOfferDetails?.offerStatus == 'Accepted' ||
              row?.buyerOfferDetails?.offerStatus == 'Rejected'
                ? `<span style="font-family: Poppins; font-weight: 550; color: #666666;">
                  ${
                    manageOfferData?.buyerDetails?.buyerName ||
                    row?.buyerDetails?.user?.userName
                  }
                  ${
                    manageOfferData?.buyerDetails?.buyerSurName ||
                    row?.buyerDetails?.user?.userSurName
                  }
                </span>
                <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                  has been notified  that their offer of
                </span>
                <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                  ${offerPopupPrice || lastItem?.offerPrice}
                </span>
                <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                  has been
                </span>
                <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                  ${
                    vendorStatusHistory ||
                    vendorStatus ||
                    row?.status ||
                    row?.buyerOfferDetails?.offerStatus
                  }
                </span>.`
                : vendorStatusHistory == 'Counter Offer' ||
                  vendorStatus == 'Counter Offer' ||
                  row?.status == 'Counter Offer' ||
                  row?.buyerOfferDetails?.offerStatus == 'Counter Offer'
                ? `<span style="font-family: Poppins; font-weight: 550; color: #666666;">
                  ${
                    manageOfferData?.buyerDetails?.buyerName ||
                    row?.buyerDetails?.user?.userName
                  }
                  ${
                    manageOfferData?.buyerDetails?.buyerSurName ||
                    row?.buyerDetails?.user?.userSurName
                  }
                </span>
                <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                  has been notified the vendor submitted a
                </span>
                <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                  Counter Offer
                </span>
                <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                  of
                </span>
                <span style="font-family: Poppins; font-weight: 550; color: #666666;">
                  ${offerPopupPrice || lastItem?.offerPrice}
                </span>.`
                : res?.message;

            getManageOfferData();
            setOpenVendorStatusBox(!openVendorStatusBox);
            getListInfo();
            setForwardVendorLoading(false);
            Swal.fire({
              title: res?.heading ? res?.heading : 'Success',
              html: successMessage,
              icon: 'success',
              confirmButtonText: 'Close',
            }).then((result) => {
              if (result.isConfirmed) {
                const isMarketShared = openFromForwardIconClick
                  ? sharedToMarket
                  : manageOfferData.offerHistory[0].isMarket;
                if (isMarketShared != 1) {
                  setShareMarketPlace(true);
                }
                openFromForwardIconClick && setOpenFromForwardIconClick(false);
              } else if (result.isDenied) {
                return;
              }
            });
          } else {
            setForwardVendorLoading(false);
            setOpenVendorStatusBox(!openVendorStatusBox);
            Swal.fire({
              title: res?.heading ? res?.heading : 'Error',
              text: res?.message,
              icon: 'error',
              confirmButtonText: 'Close',
            });
          }
        })
        .catch(() => setForwardVendorLoading(false));
    }
  }, [shouldTriggerConfirmAfterPopup]);

  const handleForwardIconClick = ({
    isFwdToBuyer,
    isFwdToVendor,
    offerPopupUniqueId,
    offerPopupPrice,
    vendorStatusHistory,
    buyerOfferPrice,
    sharedToMarket,
  }) => {
    setOpenFromForwardIconClick(true);
    if (isFwdToBuyer == 1) {
      setOpenVendorStatusBox(!openVendorStatusBox);
      setOfferPopupUniqueId(offerPopupUniqueId);
      setOfferPopupPrice(offerPopupPrice);
      setBuyerOfferPrice(buyerOfferPrice);
      setVendorStatusHistory(vendorStatusHistory);
      setSharedToMarket(sharedToMarket);
      setTableOfferData(false);
    } else if (isFwdToVendor == 1) {
      setOpenBox(!openBox);
      setOfferPopupUniqueId(offerPopupUniqueId);
      setOfferPopupPrice(offerPopupPrice);
      setSelectedOffer(offerPopupUniqueId);
      setTableOfferData(false);
    }
  };
  const offerStatusLastUpdated = formatDateTime(
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.lastUpdated
  );
  const lastUpdatedCounter = formatDateTime(
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.lastUpdatedCounter
  );

  const [selectedOffer, setSelectedOffer] = useState();
  const [selectedOfferPrice, setSelectedOfferPrice] = useState(null);

  const handleCheckboxChange = useCallback((offerId, offerPrice) => {
    setSelectedOffer((prev) => {
      if (prev === offerId) {
        setSelectedOfferPrice(null);
        return null;
      } else {
        setSelectedOfferPrice(offerPrice);
        return offerId;
      }
    });
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);
  const dialogContentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (dialogContentRef.current) {
        setIsScrolled(dialogContentRef.current.scrollTop > 10);
      }
    };

    dialogContentRef.current?.addEventListener('scroll', handleScroll);
    return () =>
      dialogContentRef.current?.removeEventListener('scroll', handleScroll);
  }, []);

  const handleVendorOfferChange = (e) => {
    setErrorMessage({ helperText: '', error: false });

    const input = e.target;
    const selectionStart = input.selectionStart;
    const oldValue = input.value;

    // Extract raw digits (remove all non-digits), limit to 9
    let rawValue = oldValue.replace(/\D/g, '').slice(0, 9);

    // Format value with commas for input display
    const formattedValue =
      rawValue === '' ? '' : Number(rawValue).toLocaleString('en-US');

    setVendorOffer(rawValue); // show formatted in input

    // ✨ Inline raw value for API (without commas)

    requestAnimationFrame(() => {
      if (
        input &&
        typeof input.setSelectionRange === 'function' &&
        document.activeElement === input
      ) {
        // Calculate digits before cursor from old input
        const digitsBeforeCursor = oldValue
          .slice(0, selectionStart)
          .replace(/\D/g, '').length;

        // Reposition cursor to the correct logical place
        let cursorPos = 0;
        let digitCount = 0;

        for (let i = 0; i < formattedValue.length; i++) {
          if (/\d/.test(formattedValue[i])) {
            digitCount++;
          }
          if (digitCount === digitsBeforeCursor) {
            cursorPos = i + 1;
            break;
          }
        }

        if (digitCount < digitsBeforeCursor) {
          cursorPos = formattedValue.length;
        }

        input.setSelectionRange(cursorPos, cursorPos);
      }
    });
  };

  useEffect(() => {
    if (
      loading ||
      buyerToVendorLoading ||
      buyerLoader ||
      openOfferValLoader ||
      frdOfferToVendorLoading
    ) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [
    loading,
    buyerToVendorLoading,
    buyerLoader,
    openOfferValLoader,
    frdOfferToVendorLoading,
  ]);

  const [openCampaignRestrictedPopup, setOpenCampaignRestrictedPopup] =
    useState(false);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        hideBackdrop={modalIsOpen}
        disableEnforceFocus={modalIsOpen}
        disableAutoFocus={modalIsOpen}
        fullWidth
        fullScreen={matchessm}
        maxWidth={matches700 ? false : 'md'}
        slotProps={{
          root: {
            style: {
              pointerEvents: modalIsOpen ? 'none' : 'auto', // 🔥 conditional
            },
          },
        }}
        sx={{
          '& .MuiPaper-root': {
            pointerEvents: 'auto', // dialog always clickable
            scrollbarWidth: 'none',
            background: '#FFF',
            padding: isScrolled ? '0px 5px 5px 5px' : '5px 5px 5px 5px',
            borderRadius: '5px',
            maxWidth: '721px',
            height: matches400 ? '500px' : matches700 ? '650px' : '928px',
          },
        }}
      >
        <Grid
          container
          sx={{
            position: 'sticky',
            top: '0',
            zIndex: 1000,
            backgroundColor: 'white',
            ml: matchessm ? '5px' : '25px',
            mt: '5px',
            width: '90%',
          }}
        >
          <Grid item>
            <Typography
              sx={[styles.Title, { fontSize: matchessm ? '12px' : '' }]}
            >
              {manageOfferData?.propertyAddress}{' '}
            </Typography>
          </Grid>
        </Grid>
        <DialogContent
          sx={{
            flex: 1,
            overflow: 'auto',
            pt: '0px',
            p: matches400 ? '10px' : '20px 24px',
            '-webkit-scrollbar': {
              display: 'none',
            },
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none',
          }}
        >
          <Grid>
            <Grid>
              <Grid
                container
                sx={styles.ManageOfferDiv}
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid
                  item
                  sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <Offer item />{' '}
                  <Typography
                    item
                    sx={[
                      styles.ManageOffer,
                      {
                        fontSize: matchessm ? '18px' : '24px',
                        display: 'inline-block',
                      },
                    ]}
                  >
                    {primaryUserTypeValue == 'Buyer'
                      ? 'Offer Details'
                      : Glass
                      ? 'Manage Current Offer'
                      : 'Manage Offer'}
                  </Typography>
                </Grid>
                {primaryUserTypeValue == 'Buyer' && (
                  <Grid
                    item
                    sx={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    <BadgeButton
                      offerStatus={
                        manageOfferData?.offerHistory?.[0]?.historyStatus ==
                          'Offer Withdrawn' &&
                        getBuyerIndividualValue?.PropertyDetails?.offerStatus
                          ?.status == 'Counter Received'
                          ? 'Counter Offer'
                          : manageOfferData?.offerHistory?.[0]?.historyStatus ==
                              'Offer Withdrawn' &&
                            manageOfferData?.lastActiveHistory?.historyStatus ==
                              'Private Offer'
                          ? 'Private Offer'
                          : manageOfferData?.offerHistory?.[0]?.historyStatus
                      }
                      manageOffer={true}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid sx={{ marginTop: '20px' }}>
                {userType == 'Vendor' ? (
                  <Typography
                    sx={[
                      styles.ManageOffBottom,
                      { fontSize: matchessm ? '13px' : '16px' },
                    ]}
                  >
                    {
                      "You can manage the buyer's offer from here. Select a response below to send to the Buyer."
                    }
                  </Typography>
                ) : !agentSubText ? (
                  <Typography
                    sx={[
                      styles.ManageOffBottom,
                      { fontSize: matchessm ? '13px' : '16px' },
                    ]}
                  >
                    {Glass
                      ? 'You can manage the most recent offer from here. Select a response below to send to the Buyer.'
                      : vendorside
                      ? "You can manage the buyer's offer from here. Select a response below to send to the Buyer."
                      : 'Manage the buyers offer from here. Notify the buyer of the Vendors decision from this screen.'}
                  </Typography>
                ) : (
                  <Typography
                    sx={[
                      styles.ManageOffBottom,
                      { fontSize: matchessm ? '13px' : '16px' },
                    ]}
                  >
                    {lastItem?.historyStatus == 'Offer Received' ? (
                      "Notify the Vendor of the Buyer's response."
                    ) : lastItem?.historyStatus == 'Accepted' ||
                      lastItem?.historyStatus == 'Rejected' ||
                      lastItem?.historyStatus == 'Counter Offer' ? (
                      " Notify the buyer of the Vendor's response."
                    ) : (
                      <>
                        You can manage the{' '}
                        <b
                          style={{
                            fontFamily: 'Poppins',
                            fontWeight: 550,
                            color: '#666666',
                          }}
                        >
                          {' '}
                          {manageOfferData?.buyerDetails?.buyerName ||
                            row?.buyerDetails?.user?.userName}{' '}
                          {manageOfferData?.buyerDetails?.buyerSurName ||
                            row?.buyerDetails?.user?.userSurName}{' '}
                        </b>
                        's offer from here.
                      </>
                    )}
                  </Typography>
                )}
              </Grid>
              {primaryUserTypeValue == 'Buyer' &&
                (manageOfferData?.offerHistory?.[0]?.historyStatus ==
                  'Counter Offer' ||
                  manageOfferData?.offerHistory?.[0]?.historyStatus ==
                    'Private Offer') && (
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: matchessm ? '5px' : '20px',
                      alignItems: 'center',
                      justifyContent: matches400
                        ? 'space-between'
                        : 'space-around',
                      width: '100%',
                    }}
                  >
                    {/* Original Price - Always show when variance exists */}
                    {getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.variance != null && (
                      <Grid item sx={{ textAlign: 'center' }}>
                        <Box>
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: matchessm ? '14px' : '24px',
                              color: '#112347',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.price || '-'}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: matches400 ? '8px' : '12px',
                              color: 'rgba(17, 35, 71, 0.5)',
                            }}
                          >
                            Last Updated :{' '}
                          </Typography>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: matches400 ? '8px' : '12px',
                              color: '#112347',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {offerStatusLastUpdated || '-'}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {/* Variance Display - Only show when variance is NOT null */}

                    {getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.variance != null &&
                      getBuyerIndividualValue?.PropertyDetails?.offerStatus
                        ?.priceCounter != null && (
                        <Grid item sx={{ textAlign: 'center' }}>
                          {Math.round(
                            getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.variance
                          ) === 0 ? (
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: matches400 ? '10px' : '40px',
                                color: 'rgba(16, 211, 94, 1)',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <Box
                                component="span"
                                sx={{ fontFamily: 'Arial' }}
                              >
                                ≈
                              </Box>
                            </Typography>
                          ) : Math.round(
                              getBuyerIndividualValue?.PropertyDetails
                                ?.offerStatus?.variance
                            ) < 0 ? (
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: matches400 ? '10px' : '20px',
                                color: '#F93939',
                                whiteSpace: 'nowrap',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px',
                              }}
                            >
                              {Math.abs(
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.offerStatus?.variance
                              )}
                              %
                              <Box marginBottom={1.6}>
                                <DownArrowRed
                                  width={matches400 ? '8' : '12'}
                                  height={matches400 ? '16' : '26'}
                                />
                              </Box>
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: matches400 ? '10px' : '20px',
                                color: 'rgba(16, 211, 94, 1)',
                                whiteSpace: 'nowrap',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px',
                              }}
                            >
                              {Math.round(
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.offerStatus?.variance
                              )}
                              %
                              <Box marginBottom={1.6}>
                                <Uparrow
                                  width={matches400 ? '8' : '12'}
                                  height={matches400 ? '16' : '26'}
                                />
                              </Box>
                            </Typography>
                          )}
                        </Grid>
                      )}

                    {/* Counter Offer Price - Always show when priceCounter exists */}
                    {getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.priceCounter && (
                      <Grid item sx={{ textAlign: 'center' }}>
                        <Box>
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: matchessm ? '14px' : '24px',
                              color: '#112347',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.priceCounter || '-'}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: matches400 ? '8px' : '12px',
                              color: 'rgba(17, 35, 71, 0.5)',
                            }}
                          >
                            Last Updated :{' '}
                          </Typography>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: matches400 ? '8px' : '12px',
                              color: '#112347',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {lastUpdatedCounter || '-'}
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                )}
              <Grid sx={styles.OriginalOffDiv}>
                <Typography
                  sx={[
                    styles.OriginalOffLable,
                    { fontSize: matchessm ? '12px' : '14px' },
                  ]}
                >
                  Current Offer
                </Typography>
              </Grid>
            </Grid>
            {manageOfferData?.propertyAddress == null ? (
              <Grid
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  p: '10%',
                  background: 'transparent',
                }}
              >
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '75px', width: '75px' }}
                />
              </Grid>
            ) : (
              <Grid sx={styles.ProfileBox}>
                <Grid sx={{ padding: '5px 5px 0 0 ' }}>
                  <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Grid sx={styles.DateDiv} style={{ padding: '5px 10px' }}>
                      {manageOfferData?.buyerDetails?.createdAt != null &&
                        formatBasedOnUserType(
                          manageOfferData?.buyerDetails?.createdAt,
                          primaryUserTypeValue
                        )}
                    </Grid>
                  </Grid>
                  {matchessm &&
                    primaryUserTypeValue != 'Buyer' &&
                    primaryUserTypeValue != 'Vendor' && (
                      <Grid
                        sx={{
                          display: 'flex',
                          justifyContent: 'end',
                          alignItems: 'start',
                          height: '30px',
                        }}
                      >
                        <Contact
                          row={
                            !moxouserId ? row?.buyerDetails : manageOfferData
                          }
                          directcomm={
                            !moxouserId ? directcomm : directcommBinder
                          }
                          moxouserId={moxouserId}
                        />
                      </Grid>
                    )}
                  <Grid
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '0 10px 0 0',
                    }}
                  >
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: matches600 ? 'column' : 'row',
                        alignItems: 'center',
                        gap: matches600 ? ' ' : '30px',
                        justifyContent:
                          primaryUserTypeValue == 'Buyer' && 'space-between',
                      }}
                    >
                      {primaryUserTypeValue != 'Buyer' && (
                        <Grid
                          item
                          sx={{ marginLeft: matches700 ? '15px' : '33px' }}
                        >
                          {(() => {
                            const isRowAvailable =
                              row?.buyerDetails?.user?.userProfile;
                            const isManageOfferAvailable =
                              manageOfferData?.buyerDetails?.buyerProfileImage;

                            const source = isRowAvailable
                              ? 'row'
                              : isManageOfferAvailable
                              ? 'manageOffer'
                              : null;

                            const profileImage =
                              source === 'row'
                                ? row?.buyerDetails?.user?.userProfile
                                : manageOfferData?.buyerDetails
                                    ?.buyerProfileImage;

                            const firstName =
                              source === 'row'
                                ? row?.buyerDetails?.user?.userName
                                : manageOfferData?.buyerDetails?.buyerName;

                            const lastName =
                              source === 'row'
                                ? row?.buyerDetails?.user?.userSurName
                                : manageOfferData?.buyerDetails?.buyerSurName;

                            const initials = `${
                              firstName?.charAt(0)?.toUpperCase() || ''
                            }${lastName?.charAt(0)?.toUpperCase() || ''}`;

                            return profileImage === '' ||
                              profileImage == null ||
                              userType == 'Vendor' ? (
                              <Box
                                sx={{
                                  position: 'relative',
                                  display: 'inline-flex',
                                }}
                              >
                                <CircularProgress
                                  variant="determinate"
                                  value={100}
                                  sx={{ color: '#C4C4C461' }}
                                  thickness={5}
                                  size={100}
                                />
                                <CircularProgress
                                  variant="determinate"
                                  value={manageOfferData?.profileActivity}
                                  sx={{
                                    color: '#10D35E',
                                    position: 'absolute',
                                  }}
                                  thickness={5}
                                  size={100}
                                />
                                <Box
                                  sx={{
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    position: 'absolute',
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    component="div"
                                    sx={{
                                      color: '#000000',
                                      ...poppins500,
                                      fontSize: '14px',
                                    }}
                                  >
                                    <Avatar
                                      style={{
                                        width: '82px',
                                        height: '82px',
                                        fontFamily: 'poppins',
                                        fontSize: '40px',
                                        backgroundColor: '#666666',
                                      }}
                                    >
                                      {initials}
                                    </Avatar>
                                  </Typography>
                                </Box>
                              </Box>
                            ) : (
                              <CircularProgressWithProfile
                                data={manageOfferData?.profileActivity}
                                profileImage={profileImage}
                                name={initials}
                              />
                            );
                          })()}
                        </Grid>
                      )}

                      <Grid
                        item
                        sx={{
                          display: 'flex',
                          flex: '1 1 0',
                          width: 0,
                          minWidth: 0,
                          maxWidth: '100%',
                          gap: matches600 ? '5px' : '15px',
                          marginLeft: matches600
                            ? '15px'
                            : matches650
                            ? '-20px'
                            : '',
                          padding:
                            matches450 && primaryUserTypeValue === 'Buyer'
                              ? '0 0 0 10px'
                              : !matches450 && primaryUserTypeValue === 'Buyer'
                              ? '0 0 0 36px'
                              : '0',
                        }}
                      >
                        <Box
                          sx={{
                            flex: '1 1 0',
                            width: 0,
                            minWidth: 0,
                            maxWidth: '100%',
                            overflow: 'hidden',
                          }}
                        >
                          <Stack
                            spacing={2}
                            sx={{
                              width: '100%',
                              minWidth: 0,
                            }}
                          >
                            {/* Buyer */}
                            <Stack
                              direction="row"
                              alignItems="center"
                              sx={{
                                width: '100%',
                                minWidth: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  ...styles.OriginalOffLable,
                                  width: '130px',
                                  minWidth: '130px',
                                  flexShrink: 0,
                                }}
                              >
                                Buyer:
                              </Typography>

                              <Box
                                sx={{
                                  flex: '1 1 0',
                                  width: 0,
                                  minWidth: 0,
                                  maxWidth: '100%',
                                  overflow: 'hidden',
                                }}
                              >
                                <NameTooltip
                                  name={
                                    manageOfferData?.buyerDetails?.buyerName ||
                                    row?.buyerDetails?.user?.userName ||
                                    ''
                                  }
                                  surname={
                                    primaryUserTypeValue === 'Vendor'
                                      ? manageOfferData?.buyerDetails?.buyerSurName?.charAt(
                                          0
                                        ) || ''
                                      : manageOfferData?.buyerDetails
                                          ?.buyerSurName ||
                                        row?.buyerDetails?.user?.userSurName ||
                                        ''
                                  }
                                >
                                  <Typography
                                    sx={{
                                      ...styles.OriginalOffLableData,
                                      display: 'block',
                                      width: '100%',
                                      minWidth: 0,
                                      maxWidth: '100%',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    {`${
                                      manageOfferData?.buyerDetails
                                        ?.buyerName ||
                                      row?.buyerDetails?.user?.userName ||
                                      ''
                                    } ${
                                      primaryUserTypeValue === 'Vendor'
                                        ? manageOfferData?.buyerDetails?.buyerSurName?.charAt(
                                            0
                                          ) || ''
                                        : manageOfferData?.buyerDetails
                                            ?.buyerSurName ||
                                          row?.buyerDetails?.user
                                            ?.userSurName ||
                                          ''
                                    }`.trim()}
                                  </Typography>
                                </NameTooltip>
                              </Box>
                            </Stack>

                            {/* Offer */}
                            <Stack
                              direction="row"
                              alignItems="center"
                              sx={{
                                width: '100%',
                                minWidth: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  ...styles.OriginalOffLable,
                                  width: '130px',
                                  minWidth: '130px',
                                  flexShrink: 0,
                                }}
                              >
                                Offer:
                              </Typography>

                              <Box
                                sx={{
                                  flex: '1 1 0',
                                  width: 0,
                                  minWidth: 0,
                                  maxWidth: '100%',
                                  overflow: 'hidden',
                                }}
                              >
                                {offerIsFinal == 1 &&
                                  userTypeValue == 'Agent' && (
                                    <div
                                      style={containerStyle}
                                      onMouseEnter={() => setIsHovered(true)}
                                      onMouseLeave={() => setIsHovered(false)}
                                    >
                                      <HighStar style={highManageStarStyle} />

                                      <span
                                        style={
                                          isHovered
                                            ? textVisibleStyle
                                            : textStyle
                                        }
                                      >
                                        Best & Final Offer
                                      </span>
                                    </div>
                                  )}

                                <Typography
                                  sx={[
                                    styles.OriginalOffLableData,
                                    {
                                      marginTop: matchesmd ? '0px' : '-5px',
                                      fontSize: matches380 ? '12px' : '16px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      minWidth: 0,
                                    },
                                  ]}
                                >
                                  {manageOfferData?.buyerDetails
                                    ?.currentOffer || 'No offer found'}
                                </Typography>
                              </Box>
                            </Stack>

                            {/* Offer Terms */}
                            <Stack
                              direction="row"
                              alignItems="center"
                              sx={{
                                width: '100%',
                                minWidth: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  ...styles.OriginalOffLable,
                                  width: '130px',
                                  minWidth: '130px',
                                  flexShrink: 0,
                                }}
                              >
                                Offer Terms:
                              </Typography>

                              <Box
                                sx={{
                                  flex: '1 1 0',
                                  minWidth: 0,
                                }}
                              >
                                <Typography
                                  sx={{
                                    display: 'flex',
                                    width: '95px',
                                    padding: '3px 6px',
                                    alignItems: 'flex-start',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    borderRadius: '5px',
                                    background:
                                      !manageOfferData?.buyerDetails ||
                                      manageOfferData?.buyerDetails
                                        ?.isConditional == null
                                        ? '#FFF'
                                        : manageOfferData.buyerDetails
                                            .isConditional === 1
                                        ? 'rgba(237, 11, 11, 0.60)'
                                        : '#10D35E',
                                    marginTop: matchesmd ? '0px' : '-2px',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color:
                                        manageOfferData?.buyerDetails
                                          ?.isConditional == null
                                          ? '#000'
                                          : '#FFF',
                                      fontFamily: 'Poppins',
                                      fontSize: matches380
                                        ? '8px'
                                        : manageOfferData?.buyerDetails == null
                                        ? '16px'
                                        : '10px',
                                      fontStyle: 'normal',
                                      fontWeight: 500,
                                      lineHeight: 'normal',
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    {manageOfferData?.buyerDetails
                                      ?.isConditional == null
                                      ? '-'
                                      : manageOfferData.buyerDetails
                                          .isConditional === 1
                                      ? 'Conditional'
                                      : 'Unconditional'}
                                  </Typography>
                                </Typography>
                              </Box>
                            </Stack>

                            {/* Deposit */}
                            {primaryUserTypeValue === 'Buyer' && (
                              <Stack
                                direction="row"
                                alignItems="center"
                                sx={{
                                  width: '100%',
                                  minWidth: 0,
                                }}
                              >
                                <Typography
                                  sx={{
                                    ...styles.OriginalOffLable,
                                    width: '130px',
                                    minWidth: '130px',
                                    flexShrink: 0,
                                  }}
                                >
                                  Deposit:
                                </Typography>

                                <Box
                                  sx={{
                                    flex: '1 1 0',
                                    width: 0,
                                    minWidth: 0,
                                    maxWidth: '100%',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      ...styles.OriginalOffLableData,
                                      fontWeight: 600,
                                    }}
                                  >
                                    {manageOfferData
                                      ? `${manageOfferData.depositAmount}%`
                                      : '-'}
                                  </Typography>
                                </Box>
                              </Stack>
                            )}

                            {/* Settlement */}
                            {primaryUserTypeValue === 'Buyer' && (
                              <Stack
                                direction="row"
                                alignItems="center"
                                sx={{
                                  width: '100%',
                                  minWidth: 0,
                                }}
                              >
                                <Typography
                                  sx={{
                                    ...styles.OriginalOffLable,
                                    width: '130px',
                                    minWidth: '130px',
                                    flexShrink: 0,
                                  }}
                                >
                                  Settlement:
                                </Typography>

                                <Box
                                  sx={{
                                    flex: '1 1 0',
                                    width: 0,
                                    minWidth: 0,
                                    maxWidth: '100%',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      ...styles.OriginalOffLableData,
                                      fontWeight: 600,
                                    }}
                                  >
                                    {manageOfferData?.settlementDays !==
                                    undefined
                                      ? `${manageOfferData.settlementDays} ${
                                          Number(
                                            manageOfferData.settlementDays
                                          ) === 1
                                            ? 'day'
                                            : 'days'
                                        }`
                                      : '-'}
                                  </Typography>
                                </Box>
                              </Stack>
                            )}
                          </Stack>
                        </Box>
                      </Grid>
                      {primaryUserTypeValue == 'Buyer' && (
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            paddingY: '10px',
                          }}
                        >
                          <MeterChartOffer
                            fromBuyerManageOffer={true}
                            priceEstimate={manageOfferData?.priceEstimate ?? 0}
                            offerValue={currentAmount ?? 0}
                          />
                        </Grid>
                      )}
                    </Grid>
                    {!matchessm &&
                      primaryUserTypeValue != 'Buyer' &&
                      primaryUserTypeValue != 'Vendor' && (
                        <Grid
                          sx={{
                            display: 'flex',
                            gap: '10px',
                            marginLeft:
                              matches450 && !matches400
                                ? '-50px'
                                : matches600
                                ? '-30px'
                                : '',
                            height: '30px',
                          }}
                        >
                          <Contact
                            row={
                              !moxouserId ? row?.buyerDetails : manageOfferData
                            }
                            directcomm={
                              !moxouserId ? directcomm : directcommBinder
                            }
                            moxouserId={moxouserId}
                          />
                        </Grid>
                      )}
                  </Grid>
                  {primaryUserTypeValue != 'Buyer' && (
                    <Grid
                      sx={{
                        padding: matches450
                          ? '27px 0 0 10px'
                          : '27px 0 0 36px ',
                      }}
                    >
                      <Grid
                        container
                        sx={{
                          display: 'flex',
                          flexDirection: matches401 && 'column',
                          alignItems: 'center',
                          gap: matches600 ? '10px' : '60px',
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                          }}
                        >
                          <ContractReview />
                          <Typography
                            sx={{
                              color: 'var(--Navigation-icon-color, #112347)',
                              fontFamily: 'Poppins',
                              fontSize: '14px',
                              fontStyle: 'normal',
                              fontWeight: 300,
                              lineHeight: 'normal',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Contract Review:
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            width: matches600 ? '89px' : '129px',
                            padding: ' 2px 50px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            borderRadius: '5px',
                            background:
                              manageOfferData?.ContactReview ==
                              'Action Required'
                                ? '#F93939'
                                : manageOfferData?.ContactReview ==
                                  'In Progress'
                                ? '#F39800'
                                : '#10D35E',
                          }}
                        >
                          <Typography
                            sx={{
                              color: 'var(--White, #FFF)',
                              textAlign: 'center',
                              fontFamily: 'Poppins',
                              fontSize: '10px',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              lineHeight: 'normal',
                              textTransform: 'capitalize',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {manageOfferData?.ContactReview}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        sx={{
                          display: 'flex',
                          flexDirection: matches401 && 'column',
                          alignItems: 'center',
                          gap: matches600 ? '10px' : '60px',
                          marginTop: '8px',
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                          }}
                        >
                          <SixtysixW />
                          <Typography
                            sx={{
                              color: 'var(--Navigation-icon-color, #112347)',
                              fontFamily: 'Poppins',
                              fontSize: '14px',
                              fontStyle: 'normal',
                              fontWeight: 300,
                              lineHeight: 'normal',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            s66W Certificate:
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            width: matches600 ? '89px' : '129px',
                            padding: ' 2px 50px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            borderRadius: '5px',
                            background:
                              manageOfferData?.wStatus == 'Action Required'
                                ? '#F93939'
                                : manageOfferData?.wStatus == 'Requested'
                                ? 'grey'
                                : '#10D35E',
                            marginLeft: matches400 ? '' : '7px',
                          }}
                        >
                          <Typography
                            sx={{
                              color: 'var(--White, #FFF)',
                              textAlign: 'center',
                              fontFamily: 'Poppins',
                              fontSize: '10px',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              lineHeight: 'normal',
                              textTransform: 'capitalize',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {manageOfferData?.wStatus}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Grid>
                    {manageOfferData?.conditionList != '' && (
                      <Grid
                        container
                        sx={{
                          display: 'flex',
                          gap: '10px',
                          flexDirection: matches600 ? 'column' : 'row',
                          justifyContent: 'space-around',
                          marginTop: '10px',
                          padding: '10px',
                        }}
                      >
                        {manageOfferData?.conditionList?.map((item, index) => {
                          const isAdditionalCondition =
                            item.conditionSubjectCode === 'SubtoAdd001';

                          return (
                            <AdditionalConditionTooltip
                              key={`${item.conditionSubjectCode}-${index}`}
                              comment={item.additionalCondition}
                              disabled={!isAdditionalCondition}
                            >
                              <Grid
                                item
                                sx={{
                                  ...styles.FeatureItemDiv,
                                  minWidth: matches600 ? '100%' : '106px',
                                  cursor: isAdditionalCondition
                                    ? 'pointer'
                                    : 'default',
                                }}
                              >
                                <Box marginTop="5px">
                                  {item.conditionSubjectCode ===
                                  'SubtoDep001' ? (
                                    <Typography sx={{ fontSize: '20px' }}>
                                      {item.conditionSubjectFile}%
                                    </Typography>
                                  ) : item.conditionSubjectCode ===
                                    'SubtoSettle001' ? (
                                    <Typography sx={{ fontSize: '20px' }}>
                                      {item.conditionSubjectFile}
                                    </Typography>
                                  ) : (
                                    <img
                                      src={item.conditionSubjectFile}
                                      alt="file"
                                      width="20"
                                      height="25"
                                    />
                                  )}
                                </Box>

                                <Grid
                                  sx={{
                                    ...styles.FeatureTxt,
                                    whiteSpace: matches600 ? 'nowrap' : '',
                                    fontSize: matches600 ? '10px' : '12px',
                                    width: matchessm ? '100%' : '110px',
                                  }}
                                >
                                  {item.conditionSubjectValue}
                                </Grid>
                              </Grid>
                            </AdditionalConditionTooltip>
                          );
                        })}
                      </Grid>
                    )}
                  </Grid>
                  {userType == 'Agent' && (
                    <Grid marginRight={'10px'} sx={{ padding: '10px' }}>
                      <Grid
                        container
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'end',
                          gap: '5px',
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                          }}
                        >
                          <Hotspot />
                          <Typography
                            sx={{
                              ...styles.HotspotTxt,
                              fontSize: matches500 ? '12px' : '14px',
                            }}
                          >
                            Auto Share to Marketplace:
                          </Typography>
                        </Grid>
                        <Typography
                          item
                          sx={{
                            ...styles.HotspotTxtData,
                            fontSize: matches500 ? '12px' : '14px',
                          }}
                        >
                          {manageOfferData?.offerSharing != 0
                            ? `In ${manageOfferData?.offerSharing} ${
                                manageOfferData?.offerSharing == 1
                                  ? 'Hour'
                                  : 'Hours'
                              }`
                            : 'Instantly'}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}

            {getBuyerIndividualValue?.PropertyDetails?.stageTwoCondition
              ?.UnconditionalOnly == 1 &&
              getBuyerIndividualValue?.PropertyDetails?.flagReadySign == 0 &&
              getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status ==
                'Counter Received' && (
                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    border: '1px solid',
                    borderColor: '#FF9500',
                    padding: 2,
                    alignItems: 'center',
                    m: '20px 0px',
                  }}
                >
                  <Grid
                    item
                    xs={1}
                    sx={{ display: 'flex', alignItems: 'center' }}
                  >
                    <WarningIconYELLOW
                      fontSize={isXsScreen ? 'small' : 'medium'}
                    />
                  </Grid>
                  <Grid item xs={10}>
                    <Typography
                      sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
                    >
                      In order to proceed with this Counter Offer, you will need
                      to be in an unconditional position. Please proceed with a
                      s66W Certificate from your legal representative.
                    </Typography>
                    <br />
                    <br />
                    <Typography
                      sx={{ ...poppins400, color: '#262626', fontSize: '16px' }}
                    >
                      Next Step Required:
                    </Typography>{' '}
                    <Typography
                      sx={{
                        ...poppins400,
                        color: '#007AFF',
                        fontSize: '16px',
                        cursor:
                          manageOfferData?.timerStatus === 'Pause'
                            ? 'not-allowed'
                            : 'pointer',
                      }}
                      onClick={() => {
                        if (manageOfferData?.timerStatus === 'Pause') return;
                        setTypeofsolicitorpopup('request66w');
                        setOpensolicitorpopup(true);
                      }}
                    >
                      Review s66W Certificate
                    </Typography>
                  </Grid>
                </Grid>
              )}

            {(primaryUserTypeValue != 'Buyer' || viewBuyerHistory) && (
              <Grid
                ref={offerHistoryRef}
                sx={[
                  styles.OriginalOffDiv,
                  {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  },
                ]}
              >
                <Typography
                  sx={[
                    styles.OriginalOffLable,
                    { fontSize: matchessm ? '12px' : '' },
                  ]}
                >
                  {primaryUserTypeValue == 'Buyer'
                    ? 'Offer History'
                    : 'Offer Activity Log'}
                </Typography>
                <Typography
                  onClick={handleSortClick}
                  sx={{ paddingTop: '5px', cursor: 'pointer' }}
                >
                  {sortIcon}
                </Typography>
              </Grid>
            )}

            {(primaryUserTypeValue != 'Buyer' || viewBuyerHistory) && (
              <Grid>
                {manageOfferData?.offerHistory == null ? (
                  <Grid
                    sx={{ display: 'flex', justifyContent: 'center', p: '10%' }}
                  >
                    <img
                      alt="Logo"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '75px', width: '75px' }}
                    />
                  </Grid>
                ) : (
                  <Grid>
                    {manageOfferData?.offerHistory == '' ? (
                      <Typography
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          fontFamily: 'poppins',
                          fontSize: '15px',
                        }}
                      >
                        No offer history found
                      </Typography>
                    ) : (
                      manageOfferData?.offerHistory?.map((item, index) => {
                        const isFwdToBuyer = item?.isFwdToBuyer;
                        const isFwdToVendor = item?.isFwdToVendor;
                        const offerPopupUniqueId = item?.offerUniqueId;
                        const offerPopupPrice = item?.offerPrice;
                        const buyerOfferPrice =
                          item?.historyStatus == 'Counter Offer'
                            ? item?.buyerOfferPrice
                            : item?.offerPrice;
                        const sharedToMarket = item?.isMarket;
                        const historyCode = item?.historyCode;
                        const isEnabled =
                          manageOfferData?.timerStatus === 'Start' &&
                          (isFwdToBuyer == 1 || isFwdToVendor == 1);
                        const isBlurred =
                          item?.historyCode == 'OfferRecChance001';
                        const vendorStatusHistory = item?.historyStatus;
                        return (
                          <Grid
                            key={item}
                            ref={(el) => {
                              if (el) {
                                contentRef.current[index] = el;
                              }
                            }}
                            sx={{
                              ...styles.VendorBuyerDiv,
                              minHeight:
                                expandedIndex === index ? 'auto' : '103px',
                              opacity: isBlurred ? 0.9 : 1,
                              filter: isBlurred ? 'blur(1px)' : 'none',
                              pointerEvents: 'auto',
                              cursor: 'default',
                              transition: 'all 0.3s ease-in-out',
                            }}
                          >
                            <div style={{ padding: '0 0 8px 0' }}>
                              <Box
                                sx={styles.DateDiv}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'end',
                                  padding: '10px',
                                }}
                              >
                                {userType == 'Agent'
                                  ? dayjs(item?.createdAt).format(
                                      'HH:mm:ss DD-MM-YYYY'
                                    )
                                  : dayjs(item?.createdAt).format(
                                      'HH:mm DD-MM-YYYY'
                                    )}
                              </Box>
                              <Grid
                                container
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexDirection: matches800 && 'column',
                                  justifyContent: matches800
                                    ? 'center'
                                    : 'space-between',
                                  padding: '0 18px',
                                }}
                              >
                                <Grid
                                  sx={{
                                    display: 'flex',
                                    flexDirection: matches800 && 'column',
                                    justifyContent: matches800
                                      ? 'center'
                                      : 'space-between',
                                    gap: !matches800 ? '10px' : '',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Grid item>
                                    <BadgeButton
                                      offerStatus={item?.historyStatus}
                                      manageOffer={true}
                                    />
                                  </Grid>
                                  <Grid
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      padding: '5px 0',
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: '#666',
                                        fontFamily: 'Poppins',
                                        fontSize: matchessm ? '12px' : '16px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                      }}
                                    >
                                      {item?.offerPrice}
                                    </Typography>
                                    {isBlurred && (
                                      <Box
                                        sx={{
                                          ml: 1,
                                          mb: 2,
                                          display: 'flex',
                                          alignItems: 'center',
                                          cursor: 'pointer',
                                        }}
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          setOpenCampaignRestrictedPopup(true);
                                        }}
                                      >
                                        <AiInfoIcon />{' '}
                                      </Box>
                                    )}
                                  </Grid>
                                </Grid>
                                <Grid
                                  item
                                  sx={{
                                    ...styles.VendorTxt,
                                    fontSize: matches500 ? '12px' : '14px',
                                    lineHeight: matches500 ? 'inherit' : '',
                                    padding: matches500 ? '5px 0' : '6px',
                                  }}
                                >
                                  {item?.history}
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'right',
                                  alignItems: 'center',
                                }}
                              >
                                <Grid>
                                  <div
                                    onClick={() => {
                                      if (!isEnabled) return;
                                      handleForwardIconClick({
                                        isFwdToBuyer,
                                        isFwdToVendor,
                                        offerPopupUniqueId,
                                        offerPopupPrice,
                                        vendorStatusHistory,
                                        buyerOfferPrice,
                                        sharedToMarket,
                                      });
                                    }}
                                    style={{
                                      cursor: isEnabled ? 'pointer' : 'default',
                                    }}
                                  >
                                    <ForwardOff isEnabled={isEnabled} />
                                  </div>
                                </Grid>
                                <Grid>
                                  <IconButton
                                    onClick={() => toggleExpand(index)}
                                  >
                                    {expandedIndex === index ? (
                                      <ExpandLessIcon />
                                    ) : (
                                      <ExpandMoreIcon />
                                    )}
                                  </IconButton>
                                </Grid>
                              </Grid>

                              {expandedIndex === index && (
                                <>
                                  <Grid
                                    sx={{
                                      padding: '10px',
                                      display: 'flex',
                                      flexDirection: 'row',
                                      gap: '20px',
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'left',
                                        fontFamily: 'poppins',
                                        fontSize: '18px',
                                        fontWeight: 500,
                                      }}
                                    >
                                      Offer Terms:
                                    </Typography>
                                    <Typography
                                      sx={{
                                        display: 'flex',
                                        width: '95px',
                                        height: '21px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '5px',
                                        background:
                                          item?.isConditional == 1
                                            ? 'rgba(237, 11, 11, 0.60)'
                                            : item?.isConditional == 0
                                            ? '#10D35E'
                                            : '',
                                        marginTop: '5px',
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: '#FFF',
                                          fontFamily: 'Poppins',
                                          fontSize: matches380 ? '8px' : '10px',
                                          fontStyle: 'normal',
                                          fontWeight: 500,
                                          lineHeight: 'normal',
                                          textTransform: 'capitalize',
                                        }}
                                      >
                                        {item?.isConditional == 1
                                          ? 'Conditional'
                                          : item?.isConditional == 0
                                          ? 'Unconditional'
                                          : ''}
                                      </Typography>
                                    </Typography>
                                  </Grid>
                                  <Grid>
                                    {item?.isConditional == 1 &&
                                      item?.offerCondition != '' && (
                                        <Grid
                                          container
                                          sx={{
                                            display: 'flex',
                                            gap: '10px',
                                            flexDirection: matches600
                                              ? 'column'
                                              : 'row',
                                            justifyContent: 'space-around',
                                            padding: '10px',
                                          }}
                                        >
                                          {item?.offerCondition?.map(
                                            (condition, index) => {
                                              const isAdditionalCondition =
                                                condition.conditionSubjectCode ===
                                                'SubtoAdd001';

                                              return (
                                                <AdditionalConditionTooltip
                                                  key={`${condition.conditionSubjectCode}-${index}`}
                                                  comment={
                                                    condition.additionalCondition
                                                  }
                                                  disabled={
                                                    !isAdditionalCondition
                                                  }
                                                >
                                                  <Grid
                                                    item
                                                    sx={{
                                                      ...styles.FeatureItemDiv,
                                                      minWidth: matches600
                                                        ? '100%'
                                                        : '106px',
                                                      cursor:
                                                        isAdditionalCondition
                                                          ? 'pointer'
                                                          : 'default',
                                                    }}
                                                  >
                                                    <Box marginTop="5px">
                                                      {condition.conditionSubjectCode ===
                                                      'SubtoDep001' ? (
                                                        <Typography
                                                          sx={{
                                                            fontSize: '20px',
                                                          }}
                                                        >
                                                          {
                                                            condition.conditionSubjectFile
                                                          }
                                                          %
                                                        </Typography>
                                                      ) : condition.conditionSubjectCode ===
                                                        'SubtoSettle001' ? (
                                                        <Typography
                                                          sx={{
                                                            fontSize: '20px',
                                                          }}
                                                        >
                                                          {
                                                            condition.conditionSubjectFile
                                                          }
                                                        </Typography>
                                                      ) : (
                                                        <img
                                                          src={
                                                            condition.conditionSubjectFile
                                                          }
                                                          alt="file"
                                                          width="20"
                                                          height="25"
                                                        />
                                                      )}
                                                    </Box>

                                                    <Grid
                                                      sx={{
                                                        ...styles.FeatureTxt,
                                                        whiteSpace: matches600
                                                          ? 'nowrap'
                                                          : '',
                                                        fontSize: matches600
                                                          ? '10px'
                                                          : '12px',
                                                        width: matchessm
                                                          ? '100%'
                                                          : '110px',
                                                      }}
                                                    >
                                                      {
                                                        condition.conditionSubjectValue
                                                      }
                                                    </Grid>
                                                  </Grid>
                                                </AdditionalConditionTooltip>
                                              );
                                            }
                                          )}
                                        </Grid>
                                      )}
                                  </Grid>
                                  {userType == 'Agent' &&
                                    item?.historyStatus == 'Counter Offer' && (
                                      <Grid>
                                        <CounterOfferTable
                                          tableData={tableData}
                                          manageOfferData={manageOfferData}
                                        />
                                      </Grid>
                                    )}
                                </>
                              )}
                            </div>
                          </Grid>
                        );
                      })
                    )}
                  </Grid>
                )}
              </Grid>
            )}
            {/* Forward Vendor action to Buyer */}

            {openVendorStatusBox && (
              <Dialog
                open={openVendorStatusBox}
                PaperProps={{
                  sx: {
                    borderRadius: '5px',
                    minWidth: matchessm ? '100%' : '400px',
                    boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                    padding: '30px',
                  },
                }}
              >
                <Grid container height={'100%'}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
                    >
                      {'   '}
                      {/* {address} */}
                      {manageOfferData?.propertyAddress}
                      &nbsp;
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    display={'flex'}
                    alignItems={'center'}
                    padding={'12px 0px 15px 0'}
                  >
                    <Pendingwarning />
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: matchessm ? '17px' : '24px',
                        paddingLeft: '12px',
                      }}
                    >
                      Notify Buyer -{' '}
                      {vendorStatusHistory
                        ? vendorStatusHistory
                        : lastItem?.historyStatus == 'Accepted' ||
                          lastItem?.historyStatus == 'Rejected'
                        ? lastItem?.historyStatus
                        : lastItem?.historyStatus == 'Counter Offer' &&
                          'Counter Offer'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} textAlign={'left'} paddingTop={'10px'}>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: matchessm ? '14px' : '16px',
                        color: '#666666',
                      }}
                      // whiteSpace={'nowrap'}
                    >
                      You are about to notify
                      {matchessm && <br />}
                      {''}{' '}
                      <Typography component="span">
                        <b
                          style={{
                            fontFamily: 'Poppins',
                            fontWeight: 550,
                            color: '#666666',
                          }}
                        >{`${
                          manageOfferData?.buyerDetails?.buyerName ||
                          row?.buyerDetails?.user?.userName
                        } ${
                          manageOfferData?.buyerDetails?.buyerSurName ||
                          row?.buyerDetails?.user?.userSurName
                        }`}</b>
                      </Typography>{' '}
                      of the vendor's response.
                      <br />
                      {vendorStatusHistory == 'Accepted' ||
                      vendorStatusHistory == 'Rejected' ? (
                        <>
                          This offer has been
                          <Typography component="span">
                            <b
                              style={{
                                fontFamily: 'Poppins',
                                fontWeight: 550,
                                color: '#666666',
                              }}
                            >
                              {` ${vendorStatusHistory}.`}
                            </b>
                          </Typography>
                        </>
                      ) : vendorStatusHistory == 'Counter Offer' ? (
                        <>
                          A{' '}
                          <Typography component="span">
                            <b
                              style={{
                                fontFamily: 'Poppins',
                                fontWeight: 550,
                                color: '#666666',
                              }}
                            >
                              Counter Offer
                            </b>
                          </Typography>{' '}
                          has been submitted.
                        </>
                      ) : lastItem?.historyStatus == 'Accepted' ||
                        lastItem?.historyStatus == 'Rejected' ? (
                        <>
                          This offer has been
                          <Typography component="span">
                            <b
                              style={{
                                fontFamily: 'Poppins',
                                fontWeight: 550,
                                color: '#666666',
                              }}
                            >
                              {` ${lastItem?.historyStatus}.`}
                            </b>
                          </Typography>
                        </>
                      ) : lastItem?.historyStatus == 'Counter Offer' ? (
                        <>
                          A{' '}
                          <Typography component="span">
                            <b
                              style={{
                                fontFamily: 'Poppins',
                                fontWeight: 550,
                                color: '#666666',
                              }}
                            >
                              Counter Offer
                            </b>
                          </Typography>{' '}
                          has been submitted.
                        </>
                      ) : null}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    container
                    direction="row"
                    sx={{ display: 'flex', alignItems: 'center' }}
                    justifyContent={matchessm ? 'center' : 'flex-end'}
                    gap={2}
                    marginTop={5}
                  >
                    <Grid item>
                      <Button
                        disabled={forwardVendorLoading}
                        variant="outlined"
                        style={{
                          padding: '10px 39px',
                          width: '100%',
                          height: '41px',
                          fontSize: '14px',
                          color: '#666666',
                          fontWeight: '400',
                          fontFamily: 'Poppins',
                          border: '1px solid rgba(17, 35, 71, 0.1)',
                          borderRadius: '5px',
                          textTransform: 'none',
                        }}
                        onClick={() => {
                          setOpenVendorStatusBox(!openVendorStatusBox);
                          setOfferPopupUniqueId('');
                          setOfferPopupPrice('');
                          setBuyerOfferPrice('');
                          setVendorStatusHistory('');
                          openFromForwardIconClick &&
                            setOpenFromForwardIconClick(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid
                      item
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        disabled={forwardVendorLoading}
                        variant="outlined"
                        onClick={() => {
                          setFinalOfferUniqueId(
                            openFromForwardIconClick
                              ? offerPopupUniqueId
                              : lastItem?.offerUniqueId
                          );

                          setFinalBuyerOfferPrice(
                            openFromForwardIconClick
                              ? buyerOfferPrice
                              : lastItem?.offerPrice
                          );

                          const offerStatus =
                            manageOfferData?.buyerDetails?.isExistPendingOffer;

                          const firstStatus = openFromForwardIconClick
                            ? vendorStatusHistory
                            : lastItem?.historyStatus;
                          const isOfferAcceptedOrRejected =
                            firstStatus === 'Accepted' ||
                            firstStatus === 'Rejected';

                          if (isOfferAcceptedOrRejected) {
                            setShowCounterPopup(false);
                            setShouldTriggerConfirmAfterPopup(true);
                            return;
                          }

                          if (
                            offerStatus === 'Counter Pending' ||
                            offerStatus === 'Private Pending'
                          ) {
                            setShowCounterPopup(true); // ✅ popup shows
                            setPendingOfferType(offerStatus);
                            return;
                          }

                          // Proceed directly
                          setShowCounterPopup(false);
                          setShouldTriggerConfirmAfterPopup(true);
                        }}
                        style={{
                          padding: '10px 39px',
                          width: '100%',
                          height: '41px',
                          fontSize: '14px',
                          color: '#FFFFFF',
                          fontWeight: '400',
                          fontFamily: 'Poppins',
                          background: '#4CA4D6',
                          borderRadius: '5px',
                          textTransform: 'none',
                        }}
                      >
                        Confirm
                      </Button>

                      {forwardVendorLoading && (
                        <img
                          alt="Logo"
                          src={Loading}
                          className="loaderImage"
                          style={{ height: '40px', width: '40px' }}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Dialog>
            )}

            {/* Forward Buyer action to Vendor */}

            <Dialog
              open={openforwardbuyeractiontovendorBox}
              PaperProps={{
                sx: {
                  borderRadius: '5px',
                  minWidth: matchessm ? '100%' : '700px',
                  boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                  padding: '30px',
                },
              }}
            >
              <Grid container height={'100%'}>
                <Grid item xs={12}>
                  <Typography
                    sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
                  >
                    {'   '}
                    {address}
                    &nbsp;
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  display={'flex'}
                  alignItems={'center'}
                  padding={'20px 0px'}
                >
                  <Warning />
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: '24px',
                      paddingLeft: '12px',
                    }}
                  >
                    Forward Buyer action to Vendor Counter Offer
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={matchessm ? 6 : 4.5}
                  textAlign={'left'}
                  paddingTop={'10px'}
                >
                  <Typography
                    sx={{ ...poppins500, fontSize: '18px' }}
                    whiteSpace={'nowrap'}
                  >
                    Do you like to forward this Buyer action to Vendor Counter
                    Offer?
                  </Typography>
                </Grid>

                <Grid
                  item
                  container
                  direction="row"
                  sx={{ display: 'flex', alignItems: 'center' }}
                  justifyContent={matchessm ? 'center' : 'flex-end'}
                  gap={2}
                  marginTop={4}
                >
                  <Grid item>
                    <Button
                      disabled={buyerToVendorLoading}
                      variant="outlined"
                      style={{
                        padding: '10px 39px',
                        width: '100%',
                        height: '41px',
                        fontSize: '14px',
                        color: '#666666',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        border: '1px solid rgba(17, 35, 71, 0.1)',
                        borderRadius: '5px',
                      }}
                      onClick={() =>
                        setOpenForwardBuyerActionToVendorBox(
                          !openforwardbuyeractiontovendorBox
                        )
                      }
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid
                    item
                    sx={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      disabled={buyerToVendorLoading}
                      variant="outlined"
                      onClick={() => {
                        buyeraction();
                      }}
                      style={{
                        padding: '10px 39px',
                        width: '100%',
                        height: '41px',
                        fontSize: '14px',
                        color: '#FFFFFF',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        background: '#4CA4D6',
                        borderRadius: '5px',
                      }}
                    >
                      Forward
                    </Button>
                    {buyerToVendorLoading && (
                      <img
                        alt="Logo"
                        src={Loading}
                        className="loaderImage"
                        style={{ height: '40px', width: '40px' }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Dialog>
          </Grid>
        </DialogContent>
        {userType == 'Vendor' &&
        (manageOfferData?.timerStage == 'ST2' ||
          tableData?.PropertyDetails?.stage == 'ST2' ||
          tableData?.PropertyDetails?.timerStatus == 'Pause' ||
          tableData?.PropertyDetails?.timerStatus == 'End' ||
          !lastItem?.historyStatus ||
          !(
            manageOfferData?.lastActiveHistory == 'Offer Received' ||
            manageOfferData?.lastActiveHistory == 'Rejected' ||
            manageOfferData?.lastActiveHistory == 'Counter Offer'
          ) ||
          manageOfferData?.lastActiveHistory == 'Accepted' ||
          manageOfferData?.lastActiveHistory == 'Vendor Notified' ||
          manageOfferData?.lastActiveHistory == 'Buyer Notified' ||
          manageOfferData?.lastActiveHistory == null) ? (
          ''
        ) : (
          <Grid>
            <Divider sx={{ width: '100%' }} />
            {getPrimaryOwner && (
              <Grid
                container
                sx={{
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  paddingY: '20px',
                  gap: matches500 ? '4px' : '',
                }}
              >
                <Grid
                  sx={{
                    border:
                      vendorAction == 'Rejected'
                        ? '1px solid rgba(249, 57, 57, 1)'
                        : null,
                    borderRadius: '5px',
                    // Add these Firefox-specific fixes
                    overflow: 'visible', // Prevent border clipping
                    display: 'inline-block', // Better border handling in Firefox
                    // Firefox-specific fix using @moz-document
                    '@-moz-document url-prefix()': {
                      border:
                        vendorAction == 'Rejected'
                          ? '1px solid rgba(249, 57, 57, 1)'
                          : '1px solid transparent', // Keep border visible in Firefox
                      backgroundClip: 'padding-box', // Ensure border renders properly
                    },
                  }}
                >
                  <CardActionArea
                    onClick={() => {
                      if (
                        offerValidation == 'Rejected' ||
                        offerValidation == 'Counter Offer' ||
                        offerValidation == 'Accepted'
                      )
                        return;
                      setVendorAction('Rejected');
                      setItemObj(row);
                      ClickCounterOffClose();
                    }}
                    item
                    sx={{
                      backgroundColor: '#F8F8F8',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '40px',
                      width: matches400 ? '100px' : '130px',
                      borderRadius: '5px',
                      gap: '10px',
                      cursor:
                        offerValidation == 'Rejected' ||
                        offerValidation == 'Counter Offer' ||
                        offerValidation == 'Accepted'
                          ? 'not-allowed'
                          : 'pointer',
                      // Add margin to prevent border overlap in Firefox
                      margin: '0px',
                      // Firefox-specific fix for inner element
                      '@-moz-document url-prefix()': {
                        width: matches400
                          ? 'calc(100% - 2px)'
                          : 'calc(130px - 2px)',
                        height: 'calc(40px - 2px)',
                        margin: '1px',
                      },
                    }}
                  >
                    <Reject sx={{ paddingTop: '20px' }} />
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: 'poppins',
                        lineHeight: '18px',
                        color: 'rgba(249, 57, 57, 1)',
                      }}
                    >
                      {matches700 ? 'Reject' : 'Reject Offer'}
                    </Typography>
                  </CardActionArea>
                </Grid>
                {/* Accept Offer Button */}
                <Grid
                  sx={{
                    border:
                      vendorAction == 'Accepted' ? '1px solid #10D35E' : null,
                    borderRadius: '5px',
                    // Firefox-specific fixes only
                    '@-moz-document url-prefix()': {
                      border:
                        vendorAction == 'Accepted'
                          ? '1px solid #10D35E'
                          : 'none',
                      outline: vendorAction == 'Accepted' ? 'none' : 'none',
                    },
                  }}
                >
                  <CardActionArea
                    item
                    onClick={() => {
                      if (offerValidation == 'Accepted') return;
                      setVendorAction('Accepted');
                      setItemObj(row);
                      ClickCounterOffClose();
                    }}
                    sx={{
                      backgroundColor: '#10D35E1A',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '40px',
                      width: matches400 ? '100px' : '130px',
                      borderRadius: '5px',
                      gap: '10px',
                      cursor:
                        offerValidation == 'Accepted'
                          ? 'not-allowed'
                          : 'pointer',
                    }}
                  >
                    <Accept marginTop={'20px'} />
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: 'poppins',
                        lineHeight: '18px',
                        color: 'rgba(16, 211, 94, 1)',
                      }}
                    >
                      {matches700 ? 'Accept' : 'Accept Offer'}
                    </Typography>
                  </CardActionArea>
                </Grid>
                {/* Counter Offer Button */}
                <Grid
                  sx={{
                    border:
                      vendorAction == 'Counter Offer'
                        ? '1px solid rgba(255, 0, 255, 1)'
                        : null,
                    borderRadius: '5px',
                    // Firefox-specific fix only - everything else stays exactly the same
                    '@-moz-document url-prefix()': {
                      padding: '0.5px',
                    },
                  }}
                >
                  <CardActionArea
                    item
                    onClick={() => {
                      if (
                        offerValidation == 'Accepted' ||
                        offerValidation == 'Counter Offer'
                      )
                        return;
                      ClickCounterOff();
                      setVendorAction('Counter Offer');
                      setItemObj(row);
                      scrollDown();
                    }}
                    sx={{
                      backgroundColor: '#F8F8F8',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '40px',
                      width: matches400 ? '100px' : '130px',
                      borderRadius: '5px',
                      gap: '10px',
                      cursor:
                        offerValidation == 'Accepted' ||
                        offerValidation == 'Counter Offer'
                          ? 'not-allowed'
                          : 'pointer',
                    }}
                  >
                    <CounterOff marginTop={'20px'} />
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: 'poppins',
                        lineHeight: '18px',
                        color: 'rgba(255, 0, 255, 1)',
                      }}
                    >
                      {matches700 ? 'Counter' : 'Counter Offer'}
                    </Typography>
                  </CardActionArea>
                </Grid>
              </Grid>
            )}
            <Collapse in={openCounterOffer} timeout={400} unmountOnExit>
              <Grid
                container
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingLeft: '25px',
                  paddingBottom: '20px',
                }}
              >
                <InputLabel sx={styles.OriginalOffLable}>
                  Counter price
                </InputLabel>
                <Grid>
                  <Typography>
                    <TextField
                      ref={bottomRef}
                      autoComplete="off"
                      value={vendorOfferField}
                      required
                      id="outlined-adornment-weight"
                      aria-describedby="outlined-weight-helper-text"
                      helperText={errorMessage.helperText}
                      error={errorMessage.error}
                      inputProps={{
                        'aria-label': 'weight',
                        style: { fontFamily: 'poppins' },
                      }}
                      name="name"
                      onChange={(e) => {
                        handleVendorOfferChange(e);
                      }}
                      InputProps={{
                        disableUnderline: 'true',
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& > fieldset': {
                            borderColor: 'rgba(0, 85, 255, 0.64)',
                          },
                          height: matches700 ? '38px' : '48px',
                          width: matches700 ? '100%' : '351px',
                          borderRadius: '5px',
                          marginTop: '10px',
                        },
                        '& .MuiFormHelperText-root': {
                          marginLeft: '-1px', // ✅ Left margin added for error text
                          fontFamily: 'Poppins',
                        },
                      }}
                    />
                    {errorMessage && (
                      <div
                        style={{ fontFamily: 'poppins', marginLeft: '-12px' }}
                      >
                        {' '}
                        {errorMessage.error}
                      </div>
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
        )}
        <Grid
          container
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: matches700
              ? 'center'
              : userType == 'Buyer'
              ? 'right'
              : 'space-between',
            flexDirection: matches600 ? 'column' : 'row',
            padding: matches400 ? '10px 10px 0px 10px' : '10px 25px 0px 25px',
          }}
        >
          {!lineChart && (
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: !matches600 ? 'center' : '',
                width: matches700 ? '100%' : '30%',
                mt: matches700 ? '' : '',
              }}
            >
              <Button
                disabled={loader}
                onClick={() => {
                  if (primaryUserTypeValue == 'Buyer') {
                    setViewBuyerHistory((prev) => !prev);
                  } else {
                    setManageOffer(false);
                    setOpenhistorydialog(true);
                    setOpenHistory(!openhistory);
                  }
                }}
                sx={{
                  padding: '10px 9px',
                  width: !matches700 ? '30%' : '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: viewBuyerHistory ? '#FFFFFF' : '#666',
                  backgroundColor: viewBuyerHistory ? '#4CA4D6' : 'transparent',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
                  minWidth: '160px',
                  '&:hover': {
                    color: viewBuyerHistory ? '#FFFFFF' : '#666',
                    backgroundColor: viewBuyerHistory
                      ? '#4CA4D6'
                      : 'transparent',
                  },
                }}
              >
                Offer History
              </Button>
            </Grid>
          )}

          <Grid
            item
            container
            sx={{
              display: 'flex',
              justifyContent: 'right',
              alignItems: 'center',
              flexWrap: 'nowrap',
              gap: loader ? '20px' : matches700 ? '7px' : '0',
              mt: matches700 && '7px',
              width: matches700 ? '100%' : lineChart ? '100%' : '70%',
            }}
          >
            <Button
              disabled={loader}
              onClick={() => {
                if (lineChart) {
                  setIsManualInteraction(false);
                  setManageOffer(false);
                  setManageOfferData({});
                } else {
                  onClose();
                  if (primaryUserTypeValue == 'Buyer') {
                    setViewBuyerHistory(false);
                    if (isBannerView) {
                      setIsBuyerDashboardView(false);
                    }
                  }
                }
              }}
              sx={{
                padding: '10px 39px',
                width: !matches700 ? '161px' : '100%',
                height: '41px',
                fontSize: '14px',
                color: '#666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
                margin: matches700 ? '0px !important' : '',
                marginLeft:
                  lastItem?.historyStatus === 'Counter Offer'
                    ? 0
                    : lastItem?.historyStatus !== 'Private Offer' &&
                      userType === 'Buyer' &&
                      userType !== 'Vendor' &&
                      userType !== 'Agent'
                    ? 16
                    : undefined,
              }}
            >
              {/* Close */}
              {/* Vendor */}
              {userType === 'Vendor' &&
                userType !== 'Buyer' &&
                userType !== 'Agent' &&
                (!(
                  manageOfferData?.lastActiveHistory == 'Offer Received' ||
                  manageOfferData?.lastActiveHistory == 'Rejected' ||
                  manageOfferData?.lastActiveHistory == 'Counter Offer'
                ) ||
                manageOfferData?.lastActiveHistory == 'Accepted' ||
                manageOfferData?.lastActiveHistory == 'Vendor Notified' ||
                manageOfferData?.lastActiveHistory == 'Buyer Notified' ||
                manageOfferData?.lastActiveHistory == null ||
                manageOfferData?.timerStage == 'ST2' ||
                tableData?.PropertyDetails?.stage == 'ST2' ||
                tableData?.propertyDetails?.timerStatus == 'Pause' ||
                tableData?.PropertyDetails?.timerStatus == 'End' ||
                manageOfferDataClone?.offerHistory?.length < 1
                  ? 'Close'
                  : 'Cancel')}
              {/* Agent */}
              {userType !== 'Buyer' &&
                userType !== 'Vendor' &&
                ((lastItem?.historyStatus == 'Accepted' &&
                  lastItem?.historyCode != 'BuyerAcc001') ||
                lastItem?.historyStatus == 'Rejected' ||
                lastItem?.historyStatus == 'Counter Offer' ||
                lastItem?.historyStatus == 'Offer Received'
                  ? 'Cancel'
                  : lastItem?.historyStatus == 'Vendor Notified' ||
                    lastItem?.historyStatus == 'Buyer Notified'
                  ? 'Close'
                  : 'Close')}
              {/* Buyer */}
              {userType === 'Buyer' &&
                userType !== 'Vendor' &&
                userType !== 'Agent' &&
                (lastItem?.historyStatus == 'Accepted' ||
                lastItem?.historyStatus == 'Offer Updated' ||
                lastItem?.historyStatus == 'Rejected' ||
                (lastItem?.historyStatus == 'Private Offer' &&
                  manageOfferData?.timerStatus === 'End')
                  ? 'Close'
                  : 'Cancel')}
            </Button>

            {primaryUserTypeValue == 'Buyer' &&
              lastItem?.historyStatus !== 'Counter Offer' &&
              lastItem?.historyStatus !== 'Private Offer' &&
              lastItem?.historyStatus == 'Offer Withdrawn' &&
              manageOfferData?.lastActiveHistory?.historyStatus !==
                'Private Offer' &&
              manageOfferData?.lastActiveHistory?.historyStatus !==
                'Counter Offer' && (
                <Button
                  onClick={async () => {
                    onClose();
                    if (isBannerView) {
                      setIsBuyerDashboardView(false);
                    }
                    if (matchessm) {
                      handleMakeOfferClick();
                    } else {
                      await setTabDAta('4');
                      window.scroll({
                        top: window.scrollY + window.innerHeight / 2 + 600,
                        behavior: 'smooth',
                      });
                    }
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 20px',
                    width: matches700 ? '100%' : '160px', // Full width on small screens
                    height: '41px',
                    fontSize: matches700 ? '13px' : '14px', // Smaller font on mobile
                    color: '#666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                    textTransform: 'none',
                    whiteSpace: 'nowrap', // Prevents text from wrapping
                    margin: matches700 ? '0 auto' : 'auto', // Centers button on mobile
                  }}
                >
                  Increase offer
                </Button>
              )}

            {userType == 'Buyer' &&
              lastItem?.historyStatus &&
              (lastItem?.historyStatus == 'Accepted' ||
              lastItem?.historyStatus == 'Offer Updated' ||
              lastItem?.historyStatus == 'Rejected' ||
              (lastItem?.historyStatus == 'Offer Withdrawn' &&
                getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status !=
                  'Counter Received' &&
                getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status !=
                  'Private Offer') ||
              (lastItem?.historyStatus == 'Private Offer' &&
                manageOfferData?.timerStatus === 'End')
                ? ''
                : getBuyerIndividualValue?.PropertyDetails?.stage == 'ST1' && (
                    <span
                      item
                      style={{
                        cursor: 'not-allowed',
                        display: 'flex',
                        marginLeft: loader ? '' : matches700 ? '' : '25px',
                        width: matches700 ? '100%' : '',
                      }}
                    >
                      <Button
                        disabled={
                          buyerLoader ||
                          (getBuyerIndividualValue?.PropertyDetails
                            ?.stageTwoCondition?.UnconditionalOnly == 1 &&
                            getBuyerIndividualValue?.PropertyDetails
                              ?.flagReadySign == 0 &&
                            getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.status == 'Counter Received') ||
                          manageOfferData?.timerStatus === 'Pause'
                        }
                        onClick={() => {
                          if (lastItem?.historyStatus === 'Private Offer') {
                            // Store manageOfferData in parent before closing
                            if (setManageOfferDatas) {
                              setManageOfferDatas(manageOfferData);
                            }
                            setManageOffer(false);
                            setPrivateOfferDetailsOpen(true);
                          } else if (
                            lastItem?.historyStatus === 'Offer Withdrawn' &&
                            manageOfferData?.lastActiveHistory?.historyStatus ==
                              'Private Offer'
                          ) {
                            if (setManageOfferDatas) {
                              setManageOfferDatas(manageOfferData);
                            }
                            setManageOffer(false);
                            setPrivateOfferDetailsOpen(true);
                          } else {
                            setBuyeracceptcounter(true);
                          }
                        }}
                        sx={{
                          display: 'inline-flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: '10px 39px',
                          width: !matches700 ? '161px' : '100%',
                          height: '41px',
                          fontSize: '14px',
                          color: '#FFF',
                          textTransform: 'none',
                          fontWeight: 400,
                          fontFamily: 'Poppins',
                          backgroundColor: '#4CA4D6',
                          borderRadius: '5px',
                          whiteSpace: 'nowrap',
                          '&:hover': {
                            backgroundColor: '#4CA4D6', // darker blue on hover
                          },

                          // ✅ Only affects DISABLED state
                          '&.Mui-disabled': {
                            backgroundColor: 'rgba(76, 164, 214, 0.4)', // semi-transparent blue
                            color: '#fff',
                            backdropFilter: 'blur(3px)',
                            WebkitBackdropFilter: 'blur(3px)',
                            opacity: 1,
                          },
                        }}
                      >
                        {/* Accept */}
                        Accept
                      </Button>
                      {userType == 'Buyer' && buyerLoader ? (
                        <img
                          alt="Logo"
                          src={Loading}
                          className="loaderImage"
                          style={{ height: '40px', width: '40px' }}
                        />
                      ) : null}
                    </span>
                  ))}
            {userType !== 'Buyer' && (
              <span
                item
                style={{
                  cursor: 'not-allowed',
                  display: 'flex',
                  marginLeft: loader
                    ? ''
                    : matches700
                    ? ''
                    : userType === 'Vendor' && !getPrimaryOwner
                    ? '0'
                    : '25px',
                  width: matches700 ? '100%' : '',
                }}
              >
                {userType != 'Vendor' ? (
                  !manageOfferData?.buyerDetails?.currentOffer ||
                  manageOfferData?.lastActiveHistory == 'Vendor Notified' ||
                  manageOfferData?.lastActiveHistory == 'Buyer Notified' ||
                  manageOfferData?.lastActiveHistory == 'Offer Withdrawn' ||
                  (manageOfferData?.lastActiveHistory == 'Accepted' &&
                    manageOfferData?.lastActiveHistoryCode == 'BuyerAcc001') ||
                  (manageOfferData?.lastActiveHistory == 'Accepted' &&
                    manageOfferData?.lastActiveHistoryCode ==
                      'BuyerAccPrivate001') ? (
                    ''
                  ) : (
                    <Button
                      onClick={() => {
                        if (
                          manageOfferData?.lastActiveHistory == 'Accepted' ||
                          manageOfferData?.lastActiveHistory == 'Rejected' ||
                          manageOfferData?.lastActiveHistory == 'Counter Offer'
                        ) {
                          setOpenVendorStatusBox(!openVendorStatusBox);
                        } else if (
                          manageOfferData?.lastActiveHistory == 'Offer Received'
                        ) {
                          setOpenBox(!openBox);
                          setTableOfferData(true);
                          setSelectedOffer(
                            manageOfferData?.buyerDetails?.offerUniqueId
                          );
                        }
                      }}
                      disabled={
                        manageOfferData?.timerStatus === 'Pause' ||
                        manageOfferData?.timerStatus === 'End' ||
                        manageOfferData?.lastActiveHistory ==
                          'Vendor Notified' ||
                        manageOfferData?.lastActiveHistory == 'Buyer Notified'
                      }
                      item
                      style={{
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '10px 39px',
                        width: !matches700 ? '161px' : '100%',
                        height: '41px',
                        fontSize: '14px',
                        color: '#FFF',
                        textTransform: 'none',
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                        background: '#4CA4D6',
                        borderRadius: '5px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {userType != 'Vendor'
                        ? getLabelForNotify(manageOfferData?.lastActiveHistory)
                        : 'Update'}
                    </Button>
                  )
                ) : manageOfferData?.timerStage == 'ST2' ||
                  tableData?.PropertyDetails?.stage == 'ST2' ||
                  tableData?.PropertyDetails?.timerStatus == 'Pause' ||
                  tableData?.PropertyDetails?.timerStatus == 'End' ||
                  manageOfferDataClone?.offerHistory?.length < 1 ||
                  !(
                    manageOfferData?.lastActiveHistory == 'Offer Received' ||
                    manageOfferData?.lastActiveHistory == 'Rejected' ||
                    manageOfferData?.lastActiveHistory == 'Counter Offer'
                  ) ||
                  manageOfferData?.lastActiveHistory == 'Accepted' ||
                  manageOfferData?.lastActiveHistory == 'Vendor Notified' ||
                  manageOfferData?.lastActiveHistory == 'Buyer Notified' ||
                  manageOfferData?.lastActiveHistory == null ? (
                  ''
                ) : (
                  <Button
                    onClick={() => {
                      const enteredOffer = Number(
                        vendorOffer?.replace(/,/g, '')
                      );
                      const currentOffer = Number(
                        manageOfferData?.buyerDetails?.currentOffer?.replace(
                          /[$,]/g,
                          ''
                        )
                      );
                      const isOfferconditional =
                        manageOfferData?.buyerDetails?.isConditional;

                      const buyerPosition =
                        manageOfferData?.wStatus == 'Completed'
                          ? 'an Unconditional'
                          : 'a Conditional';

                      if (
                        vendorAction == 'Counter Offer' &&
                        enteredOffer < currentOffer
                      ) {
                        setErrorMessage({
                          helperText:
                            "Counter offer must be greater than the buyer's current offer.",
                          error: true,
                        });
                        return;
                      }

                      if (
                        (vendorAction == 'Counter Offer' &&
                          enteredOffer == currentOffer &&
                          isOfferconditional == 1 &&
                          stg2UnconditionalOnly == 0) ||
                        (vendorAction == 'Counter Offer' &&
                          enteredOffer == currentOffer &&
                          isOfferconditional == 0 &&
                          stg2UnconditionalOnly == 1) ||
                        (vendorAction == 'Counter Offer' &&
                          enteredOffer == currentOffer &&
                          isOfferconditional == 0 &&
                          stg2UnconditionalOnly == 0)
                      ) {
                        Swal.fire({
                          title: 'Counter Offer Must Exceed Current Amount',
                          html: `<span style="font-family: Poppins; font-weight: 400; font-size: 18px; color: #666666;">
                                                You should not submit the same amount as the Counter Offer Price when the buyer is in ${buyerPosition} position.
                                                </span><br/>
                                                <span style="font-family: Poppins; font-weight: 500; font-size: 18px; color: #666666;">
                                                Please increase your counter offer to proceed.</span>`,
                          icon: 'warning',
                          confirmButtonText: 'Increase Offer',
                          confirmButtonColor: '#4CA4D6',
                          allowOutsideClick: false,
                        });
                        return;
                      }

                      handleVendorActionClick(
                        manageOfferData?.buyerDetails?.buyerName,
                        manageOfferData?.buyerDetails?.buyerSurName,
                        manageOfferData?.buyerDetails?.currentOffer
                      );
                    }}
                    disabled={
                      (vendorAction == 'Counter Offer' && vendorOffer == '') ||
                      loader
                    }
                    item
                    style={{
                      display: getPrimaryOwner ? 'inline-flex' : 'none',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '10px 39px',
                      pointerEvents:
                        (vendorAction == '' ||
                          (vendorAction == 'Counter Offer' &&
                            vendorOffer == '')) &&
                        'none',
                      width: !matches700
                        ? loader
                          ? '130px'
                          : '161px'
                        : '100%',
                      height: '41px',
                      fontSize: '14px',
                      color: '#FFF',
                      textTransform: 'none',
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                      background: '#4CA4D6',
                      borderRadius: '5px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Submit
                  </Button>
                )}
                {loader && (
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '40px', width: '40px' }}
                  />
                )}
              </span>
            )}
          </Grid>

          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            maxWidth="sm"
            fullWidth
            sx={{ '& .MuiDialog-paper': { padding: '10px' } }}
          >
            <DialogTitle
              sx={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontSize: '24px',
                color: '#000000',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '8px',
              }}
            >
              {' '}
              <span
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '14px',
                  fontWeight: 400,
                  color: '#000000',
                }}
              >
                {manageOfferData?.propertyAddress}
              </span>
              <span
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                {currentDialog.icon}
                {currentDialog.title}
              </span>
            </DialogTitle>
            <DialogContent>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 300,
                    fontSize: '16px',
                  }}
                >
                  {/* Accept Offer Dialog */}
                  {vendorAction === 'Accepted' && (
                    <>
                      Would you like to accept the offer of{' '}
                      <b style={{ fontWeight: 550, color: '#666666' }}>
                        {manageOfferData?.buyerDetails?.currentOffer?.includes(
                          '$'
                        )
                          ? manageOfferData?.buyerDetails?.currentOffer
                          : `$${Number(
                              manageOfferData?.buyerDetails?.currentOffer?.replace(
                                /[$,]/g,
                                ''
                              ) || 0
                            ).toLocaleString()}`}
                      </b>{' '}
                      submitted by{' '}
                      <b
                        style={{
                          fontWeight: 550,
                          color: '#666666',
                          fontFamily: 'Poppins',
                        }}
                      >
                        {manageOfferData?.buyerDetails?.buyerName}{' '}
                        {manageOfferData?.buyerDetails?.buyerSurName
                          ?.charAt(0)
                          .toUpperCase()}
                      </b>
                      ?
                    </>
                  )}

                  {/* Counter Offer Dialog */}
                  {vendorAction === 'Counter Offer' && (
                    <>
                      Are you sure you would like to submit a counter offer of{' '}
                      <b style={{ fontWeight: 550, color: '#666666' }}>
                        ${Number(vendorOffer || 0).toLocaleString('en-US')}
                      </b>{' '}
                      to{' '}
                      <b
                        style={{
                          fontWeight: 550,
                          color: '#666666',
                          fontFamily: 'Poppins',
                        }}
                      >
                        {manageOfferData?.buyerDetails?.buyerName}{' '}
                        {manageOfferData?.buyerDetails?.buyerSurName
                          ?.charAt(0)
                          .toUpperCase()}
                      </b>{' '}
                      for{' '}
                      <b style={{ fontWeight: 550, color: '#666666' }}>
                        {manageOfferData?.propertyAddress}
                      </b>
                      ?
                    </>
                  )}

                  {/* Reject Offer Dialog */}
                  {vendorAction === 'Rejected' && (
                    <>
                      Would you like to reject{' '}
                      <b
                        style={{
                          fontWeight: 550,
                          color: '#666666',
                          fontFamily: 'Poppins',
                        }}
                      >
                        {manageOfferData?.buyerDetails?.buyerName}{' '}
                        {manageOfferData?.buyerDetails?.buyerSurName
                          ?.charAt(0)
                          .toUpperCase()}
                      </b>{' '}
                      offer of{' '}
                      <b style={{ fontWeight: 550, color: '#666666' }}>
                        {manageOfferData?.buyerDetails?.currentOffer?.includes(
                          '$'
                        )
                          ? manageOfferData?.buyerDetails?.currentOffer
                          : `$${Number(
                              manageOfferData?.buyerDetails?.currentOffer?.replace(
                                /[$,]/g,
                                ''
                              ) || 0
                            ).toLocaleString()}`}
                      </b>
                      ?
                    </>
                  )}
                </Typography>
              </Box>

              {/* E-sign Note - Only for Accept and Counter Offer */}
              {(vendorAction === 'Accepted' ||
                vendorAction === 'Counter Offer') && (
                <Box mt={2}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                      fontSize: '16px',
                      color: '#666666',
                      marginTop: '12px',
                    }}
                  >
                    {vendorAction === 'Counter Offer'
                      ? 'After submitting the counter offer, you must e-sign the Acceptance Certificate to proceed further.'
                      : 'If accepting the offer, you must e-sign the Acceptance Certificate to proceed'}
                  </Typography>
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleDialogClose}
                style={{
                  backgroundColor: 'transparent',
                  color: '#666',
                  border: '1px solid #DFDFDF',
                  borderRadius: '5px',
                  padding: '10px 39px',
                  marginRight: '10px',
                  cursor: 'pointer',
                  textTransform: 'none',
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleConfirm(
                    selectedBuyerName,
                    selectedBuyerSurName,
                    currentOfferPrice
                  );
                }}
                style={{
                  backgroundColor: 'rgb(76, 164, 214)',
                  borderRadius: '5px',
                  border: '1px solid rgb(76, 164, 214)',
                  color: '#fff',
                  padding: '10px 39px',
                  cursor: 'pointer',
                  textTransform: 'none',
                }}
                disabled={loading}
              >
                {currentDialog.confirmText}
              </Button>
              {loading ? (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              ) : null}
            </DialogActions>
          </Dialog>
        </Grid>
        <Divider sx={{ marginTop: '20px', width: '100%' }} />
        <Grid
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
            gap: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            onClose && onClose();
            history.push('/helpcentre');
          }}
        >
          <NeedHelp /> Need Help?
        </Grid>
      </Dialog>

      {modalIsOpen && <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />}

      <Dialog
        open={buyeracceptcounter}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {manageOfferData?.propertyAddress}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Update Current Offer
            </Typography>
          </Grid>
          <Grid item textAlign={'left'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '12px' : '16px',
                color: '#666666',
              }}
            >
              Would you like to update your offer to match the vendor's counter
              offer of{' '}
              <span>
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {
                    getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.priceCounter
                  }
                </b>
              </span>
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? 2 : 4}
          >
            <Grid item>
              <Button
                disabled={buyerLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => setBuyeracceptcounter(!buyeracceptcounter)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                disabled={buyerLoader}
                onClick={() => {
                  submitOffer(
                    getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.priceCounter || ''
                  );
                }}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Confirm
              </Button>
              {buyerLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openOfferVal}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {manageOfferData?.propertyAddress}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Confirming Acceptance
            </Typography>
          </Grid>
          <Grid item xs={matchessm ? 6 : 4.5} textAlign={'left'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
              whiteSpace={'nowrap'}
            >
              Do you want to withdraw the last action ?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? 2 : 4}
          >
            <Grid item>
              <Button
                disabled={openOfferValLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => setOpenOfferVal(!openOfferVal)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                disabled={openOfferValLoader}
                onClick={withdrawLastFun}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Confirm
              </Button>
              {openOfferValLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={openBox}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '100%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {'   '}
              {manageOfferData?.propertyAddress}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{ ...poppins500, fontSize: '24px', paddingLeft: '12px' }}
            >
              Forward Offer to Vendor
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign={'left'} paddingTop={'10px'}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
            >
              You are about to forward{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >{`${
                  manageOfferData?.buyerDetails?.buyerName ||
                  row?.buyerDetails?.user?.userName
                } ${
                  manageOfferData?.buyerDetails?.buyerSurName ||
                  row?.buyerDetails?.user?.userSurName
                }`}</b>
              </Typography>
              's offer of{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  {(() => {
                    if (tableOfferData && selectedOfferPrice) {
                      return selectedOfferPrice;
                    }
                    if (openFromForwardIconClick && offerPopupPrice) {
                      return offerPopupPrice;
                    }
                    return manageOfferData?.buyerDetails?.currentOffer;
                  })()}
                </b>
              </Typography>{' '}
              to the Vendor.
            </Typography>
          </Grid>
          {tableOfferData &&
            manageOfferData?.offerHistory?.filter(
              (offer) => offer?.isFwdToVendor == 1
            ).length > 1 && (
              <Grid item xs={12} marginTop={3}>
                <Table sx={{ width: '100%', fontFamily: 'poppins' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        padding="checkbox"
                        sx={{ fontFamily: 'Poppins' }}
                      />
                      <TableCell
                        sx={{ fontFamily: 'Poppins', fontWeight: 500 }}
                      >
                        Offer
                      </TableCell>
                      <TableCell
                        sx={{ fontFamily: 'Poppins', fontWeight: 500 }}
                      >
                        Offer Type
                      </TableCell>
                      <TableCell
                        sx={{ fontFamily: 'Poppins', fontWeight: 500 }}
                      >
                        Offer Time & Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {manageOfferData?.offerHistory
                      ?.filter((offer) => offer?.isFwdToVendor == 1)
                      ?.map((offer, index) => (
                        <TableRow key={index}>
                          <TableCell padding="checkbox">
                            <input
                              type="checkbox"
                              checked={selectedOffer == offer?.offerUniqueId}
                              onChange={() =>
                                handleCheckboxChange(
                                  offer?.offerUniqueId,
                                  offer?.offerPrice
                                )
                              }
                              disabled={frdOfferToVendorLoading}
                            />
                          </TableCell>
                          <TableCell sx={{ fontFamily: 'Poppins' }}>
                            {offer?.offerPrice}
                          </TableCell>
                          <TableCell sx={{ fontFamily: 'Poppins' }}>
                            <Typography
                              sx={{
                                display: 'flex',
                                width: '95px',
                                padding: '3px 6px',
                                alignItems: 'flex-start',
                                justifyContent: 'center',
                                gap: '10px',
                                borderRadius: '5px',
                                background:
                                  offer?.isConditional == 1
                                    ? 'rgba(237, 11, 11, 0.60)'
                                    : '#10D35E',
                                marginTop: '-2px',
                              }}
                            >
                              <Typography
                                sx={{
                                  color: '#FFF',
                                  fontFamily: 'Poppins',
                                  fontSize: matches380 ? '8px' : '10px',
                                  fontStyle: 'normal',
                                  fontWeight: 500,
                                  lineHeight: 'normal',
                                  textTransform: 'capitalize',
                                }}
                              >
                                {offer?.isConditional == 1
                                  ? 'Conditional'
                                  : 'Unconditional'}
                              </Typography>
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ fontFamily: 'Poppins' }}>
                            {' '}
                            {offer?.createdAt
                              ? dayjs(offer?.createdAt).format(
                                  'HH:mm:ss DD-MM-YYYY'
                                )
                              : '-'}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Grid>
            )}

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginTop={5}
          >
            <Grid item>
              <Button
                disabled={frdOfferToVendorLoading}
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => {
                  setOpenBox(!openBox);
                  setSelectedOffer(null);
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={
                  frdOfferToVendorLoading ||
                  (manageOfferData?.offerHistory?.filter(
                    (offer) => offer?.isFwdToVendor == 1
                  ).length > 1 &&
                    !selectedOffer)
                }
                variant="outlined"
                onClick={() => {
                  let input = {};
                  if (
                    manageOfferData?.offerHistory?.filter(
                      (offer) => offer?.isFwdToVendor == 1
                    )?.length >= 1
                  ) {
                    input = {
                      offerUniqueId:
                        lineChart && !offerPopupUniqueId
                          ? selectedOffer
                          : lineChart && offerPopupUniqueId
                          ? offerPopupUniqueId
                          : tableOfferData
                          ? selectedOffer
                          : offerPopupUniqueId
                          ? offerPopupUniqueId
                          : row?.buyerOfferDetails?.offerUniqueId,
                    };
                  } else {
                    input = {
                      offerUniqueId: row?.buyerOfferDetails?.offerUniqueId,
                    };
                  }
                  setFrdOfferToVendorLoading(true);
                  forwardOfferToVendor(input)
                    .then((res) => {
                      if (res?.status == '1') {
                        setOpenBox(!openBox);
                        getManageOfferData();
                        getListInfo();
                        setFrdOfferToVendorLoading(false);
                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Success',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'success',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      } else {
                        setFrdOfferToVendorLoading(false);
                        setOpenBox(!openBox);

                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Error',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'error',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      }
                    })
                    .catch(() => setFrdOfferToVendorLoading(false));
                }}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Forward
              </Button>
              {frdOfferToVendorLoading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={openhistory}
        onClose={() => {
          setOpenHistory(!openhistory);
        }}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '100%' : '80%',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid container>
            <Grid item xs={6} display={'flex'} alignItems={'center'}>
              <Warning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matches600 ? '16px' : '24px',
                  paddingLeft: '12px',
                  whiteSpace: 'nowrap',
                }}
              >
                Offer history
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'right',
                border: 'none',
              }}
            >
              <img src={Arrow1} />
              <Typography
                onClick={() => {
                  setOpenHistory(!openhistory);
                  setOpenhistorydialog(false);
                  setManageOffer(true);
                }}
                sx={{
                  color: '#6C2AD2',
                  fontWeight: 300,
                  fontSize: matches600
                    ? matches400
                      ? '10px'
                      : '12px'
                    : '14px',
                  cursor: 'pointer',
                  paddingLeft: '15px',
                  fontFamily: 'poppins',
                }}
              >
                Back to Manage Offer
              </Typography>
            </Grid>
          </Grid>

          <Offeractivity
            offerdata={offerdata}
            openhistory={openhistory}
            getdata={getdata}
            tablerow={tablerow}
          />
        </Grid>
      </Dialog>
      {shareMarketPlace && (
        <ShareOfferWithMarketPlace
          shareMarketPlace={shareMarketPlace}
          setShareMarketPlace={setShareMarketPlace}
          getListInfo={getListInfo}
          address={manageOfferData?.propertyAddress}
          offerUniqueId={finalOfferUniqueId}
          selectedrowbuyername={
            manageOfferData?.buyerDetails?.buyerName +
            ' ' +
            manageOfferData?.buyerDetails?.buyerSurName
          }
          buyerOfferPrice={finalBuyerOfferPrice}
        />
      )}

      {showCounterPopup && (
        <CounterOfferalreadyexists
          open={showCounterPopup}
          manageOfferData={manageOfferData}
          pendingOfferType={pendingOfferType}
          onClose={() => setShowCounterPopup(false)} // corrected from onCloses
          onContinue={() => {
            setShowCounterPopup(false); // close popup
            setShouldTriggerConfirmAfterPopup(true); // trigger API
          }}
        />
      )}

      {/* This is now using the prop from parent, not local state */}
      <PrivateOfferDetails
        open={privateOfferDetailsOpen}
        setPrivateOfferDetailsOpen={setPrivateOfferDetailsOpen}
        setBuyeracceptcounter={setBuyeracceptcounter}
        getBuyerIndividualValue={getBuyerIndividualValue}
        manageOfferData={manageOfferData}
        tableData={tableData}
        propertyDetails={propertyDetails}
        setManageOffer={onClose}
        groupIt={groupIt}
        groupCall={groupCall}
        getListInfo={getListInfo}
        setManageOfferDatas={setManageOfferDatas}
        setManageOfferss={setManageOffer}
        setOpensolicitorpopup={setOpensolicitorpopup}
        setTypeofsolicitorpopup={setTypeofsolicitorpopup}
      />
      <CampaignRestrictedPopup
        open={openCampaignRestrictedPopup}
        setOpen={setOpenCampaignRestrictedPopup}
        agentBuyerBinderId={
          getBuyerIndividualValue?.PropertyDetails?.agentBuyerBinderId
        }
      />
    </React.Fragment>
  );
}

var styles = {
  Title: {
    color: '#666',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  ManageOfferDiv: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    gap: '10px',
  },
  ManageOffer: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
  },
  ManageOffBottom: {
    color: ' #666',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    textAlign: 'justify',
  },
  OriginalOffDiv: {
    maxWidth: '656px',
    borderRadius: '5px',
    border: '0.5px solid #E4E4E4',
    background: 'rgba(188, 187, 188, 0.10)',
    padding: '8px 12px',
    marginTop: '27px',
  },
  OriginalOffLable: {
    color: '#26344E',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
  },
  OriginalOffLableData: {
    color: '#666',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  ProfileBox: {
    maxWidth: '656px',
    minHeight: '275px',
    flexShrink: 0,
    borderRadius: '5px',
    background: '#FFF',
    boxShadow: '0px 1px 6px 0px rgba(0, 0, 0, 0.15)',
    marginTop: '17px',
  },
  ProfileBoxTop: {
    display: 'flex',
    alignItems: 'center',
  },
  FeatureItemDiv: {
    borderRadius: '8px',
    border: '1px solid #DFDFDF',
    background: '#FFF',
    minHeight: '92px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  FeatureTxt: {
    color: '#666',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    minHeight: '36px',
  },
  HotspotTxt: {
    color: 'var(--ParagraphColor, #666)',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  HotspotTxtData: {
    color: '#6C2AD2',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  VendorBuyerDiv: {
    maxWidth: '656px',
    minHeight: '103px',
    flexShrink: 0,
    borderRadius: '5px',
    background: '#FFF',
    boxShadow: ' 0px 1px 6px 0px rgba(0, 0, 0, 0.15)',
    marginTop: '15px',
  },
  VendorTxt: {
    color: '#666',
    fontfamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: 'normal',
    textAlign: 'justify',
  },
  DateDiv: {
    color: '#AEAEAE',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  Reject: {
    backgroundColor: '#F8F8F8',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '116px',
    width: '116px',
    borderRadius: '5px',
    gap: '15px',
  },
  Reject: {
    backgroundColor: '#F8F8F8',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '116px',
    width: '116px',
    borderRadius: '5px',
    gap: '15px',
  },
  Reject: {
    backgroundColor: '#F8F8F8',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '116px',
    width: '116px',
    borderRadius: '5px',
    gap: '15px',
  },
};
